/* TKR Sponsor Decal Sheet designer — theme asset. Built from the designer prototype by build_pack.py. */

function tkrDecalDesigner(){
// ---------- live shop set-up ----------
const ROOT=document.getElementById("tkr-dd");
if(!ROOT||ROOT.dataset.ready) return; ROOT.dataset.ready="1";
let CFG={}; try{ CFG=JSON.parse((ROOT.querySelector("#tkr-dd-config")||{}).textContent||"{}"); }catch(e){ console.error("TKR designer: settings couldn't be read",e); }
Array.from(document.getElementsByClassName("tkr-dd-layer")).forEach(l=>l.remove());   // left over from a theme-editor re-render
// pop-ups live in a layer on <body> so no theme container can clip them
const LAYER=document.createElement("div"); LAYER.className="tkr-dd tkr-dd-layer"; LAYER.style.cssText=ROOT.style.cssText;
document.body.appendChild(LAYER);
["welcome","tour","browser"].forEach(id=>{ const el=ROOT.querySelector("#"+id); if(el) LAYER.appendChild(el); });
const QS=s=>ROOT.querySelector(s)||LAYER.querySelector(s);
const QSA=s=>[...ROOT.querySelectorAll(s),...LAYER.querySelectorAll(s)];
// ---------- production rules (from the Illustrator decal scripts) ----------
const OFFSET = 1.5;        // mm per outline
const BLEED = 0.5;         // mm beyond cut line
const CUT_GAP = 3.5;       // minimum mm between the cut lines of two decals
const HALF = CUT_GAP/2;    // each decal keeps this clear zone around its cut line
// Your two TKR sheet templates. Sizes come from each SVG's artboard (points x 25.4/72);
// the decal area is the inside of the coloured frame, and decals are kept INSET mm clear of it.
const SHEETS = {
  A4:{label:"A4", file:(CFG.templates&&CFG.templates.A4)||"sheet-template.svg", name:"TKR BLANK_A4_SPONSOR_SHEET", fluoroFile:(CFG.templates&&CFG.templates.A4F)||"sheet-template-fluoro-a4.svg", fluoroName:"TKR BLANK_FLUORESCENT_A4_SHEET", w:316.5, h:214.5,
      frame:{x0:2.25, y0:2.25, x1:295.25, y1:212.25}},
  A5:{label:"A5", file:(CFG.templates&&CFG.templates.A5)||"sheet-template-a5.svg", name:"TKR BLANK_A5_DECALS_SHEET", fluoroFile:(CFG.templates&&CFG.templates.A5F)||"sheet-template-fluoro-a5.svg", fluoroName:"TKR BLANK_FLUORESCENT_SPONSOR_A5_DECALS_SHEET", w:625.039*25.4/72, h:428.032*25.4/72,
      frame:{x0:6.061*25.4/72, y0:6.379*25.4/72, x1:564.929*25.4/72, y1:421.654*25.4/72}}
};
const SHEET = {}, FRAME = {}, AREA = {};
const INSET = 3;
let GW = 0, GH = 0;
function setSheetGeometry(size){
  const t=SHEETS[size]; Object.assign(SHEET,{w:t.w,h:t.h}); Object.assign(FRAME,t.frame);
  Object.assign(AREA,{x0:FRAME.x0+INSET,y0:FRAME.y0+INSET,x1:FRAME.x1-INSET,y1:FRAME.y1-INSET});
  GW=Math.ceil(SHEET.w); GH=Math.ceil(SHEET.h);
}
setSheetGeometry("A4");
const mm1=v=>(Math.round(v*10)/10).toString();
const outside = c => c.x0<AREA.x0-.01||c.y0<AREA.y0-.01||c.x1>AREA.x1+.01||c.y1>AREA.y1+.01;
const MATPAD = 10;         // mm of cutting mat shown around sheet

// Roland VersaWorks palette (codes known so far; the rest need your real swatch codes)
// TKR Roland VersaWorks range (ROLAND_COLOUR_SWATCHES.csv). "swatch" is the spot colour the RIP uses;
// "hex" is an on-screen preview tuned to look like the printed ink, not the raw CMYK maths.
const COLOURS = [
  {name:"White",       code:"01A", swatch:"RVW-BK01A", cmyk:"0/0/0/0",     hex:"#ffffff"},
  {name:"Light Grey",  code:"05A", swatch:"RVW-BK05A", cmyk:"0/0/0/20",    hex:"#d1d3d4"},
  {name:"Dark Grey",   code:"13A", swatch:"RVW-BK13A", cmyk:"0/0/0/60",    hex:"#6d6e71"},
  {name:"Black",       code:"21A", swatch:"RVW-BK21A", cmyk:"0/0/0/100",   hex:"#151515"},
  {name:"Yellow",      code:"01K", swatch:"RVW-PR01K", cmyk:"0/0/100/0",   hex:"#fff200"},
  {name:"Light Green", code:"07K", swatch:"RVW-PR07K", cmyk:"43/0/100/0",  hex:"#9bca3e"},
  {name:"Green",       code:"10K", swatch:"RVW-PR10K", cmyk:"77/0/100/0",  hex:"#3fae49"},
  {name:"Cyan",        code:"19K", swatch:"RVW-PR19K", cmyk:"100/0/0/0",   hex:"#00aeef"},
  {name:"Blue",        code:"21K", swatch:"RVW-PR21K", cmyk:"100/28/0/0",  hex:"#008fd5"},
  {name:"Deep Blue",   code:"23K", swatch:"RVW-PR23K", cmyk:"100/57/0/0",  hex:"#0066b3"},
  {name:"Navy Blue",   code:"25K", swatch:"RVW-PR25K", cmyk:"100/85/0/0",  hex:"#21409a"},
  {name:"Deep Purple", code:"28K", swatch:"RVW-PR28K", cmyk:"78/100/0/0",  hex:"#5c2d91"},
  {name:"Purple",      code:"31K", swatch:"RVW-PR31K", cmyk:"45/100/0/0",  hex:"#92278f"},
  {name:"Pink",        code:"35K", swatch:"RVW-PR35K", cmyk:"0/100/0/0",   hex:"#ec008c"},
  {name:"Red",         code:"43K", swatch:"RVW-PR43K", cmyk:"0/100/100/0", hex:"#ed1c24"},
  {name:"Orange",      code:"46K", swatch:"RVW-PR46K", cmyk:"0/62/100/0",  hex:"#f47920"},
];
// ---------- vinyl: standard white, or one of five fluoro vinyls ----------
// On fluoro, black is the only opaque ink. Every other colour is printed over an RDG_WHITE underbase
// (same shape, no choke). White on fluoro is RDG_WHITE on its own. The cutter can't cut through
// stacked ink, so the outer layer, which carries the cut line and bleed, is always the bare vinyl (no ink).
if(Array.isArray(CFG.colours)&&CFG.colours.length)
  { const seen=new Set(); COLOURS.splice(0,COLOURS.length,...CFG.colours.filter(c=>c&&c.hex).map(c=>({name:c.name||c.code,code:c.code||"",swatch:c.swatch||"",hex:String(c.hex).toLowerCase()})).filter(c=>{ const k=c.code||c.hex; if(seen.has(k)||seen.has(c.hex)) return false; seen.add(k); seen.add(c.hex); return true; })); }   // a colour added twice in the theme editor shows once
const WHITE_INK={code:String(CFG.whiteInk||"RDG_WHITE").trim()||"RDG_WHITE",swatch:String(CFG.whiteInk||"RDG_WHITE").trim()||"RDG_WHITE"};
const colourByCode = (code,fallback) => (COLOURS.find(c=>c.code.toLowerCase()===String(code||"").trim().toLowerCase())||COLOURS[fallback]||COLOURS[0]).hex;
const VINYLS=[
  {id:"standard", name:"Standard white", hex:"#ffffff", fluoro:false},
  {id:"holo",     name:"Holographic",    hex:"#dfe3ea", fluoro:false, holo:true},
  {id:"fyellow",  name:"Fluoro Yellow",  hex:"#e8ff1f", fluoro:true},
  {id:"fred",     name:"Fluoro Red",     hex:"#ff3b47", fluoro:true},
  {id:"forange",  name:"Fluoro Orange",  hex:"#ff7417", fluoro:true},
  {id:"fpink",    name:"Fluoro Pink",    hex:"#ff3fae", fluoro:true},
  {id:"fgreen",   name:"Fluoro Green",   hex:"#4dff3a", fluoro:true},
];
const VINYL="vinyl";                                   // colour value meaning "no ink, show the vinyl"
const vinyl=()=>VINYLS.find(v=>v.id===scheme.material)||VINYLS[0];
const isFluoro=()=>vinyl().fluoro;
const ink=h=>h===VINYL?vinyl().hex:h;                 // what to paint on screen
const BLACK_CODE="21A";
const isBlack=h=>(COLOURS.find(c=>c.hex===h)||{}).code===BLACK_CODE;
const cutKey=()=>scheme.outlines===2?"o2":"o1";        // the layer the cut line and bleed go through
const allowedOnCut=h=>!isFluoro()||h===VINYL;   // on fluoro the cut layer is always the bare vinyl
const colourByHex = h => h===VINYL ? {name:`${vinyl().name} vinyl (no ink)`,code:"",hex:vinyl().hex,vinyl:true}
  : (COLOURS.find(c=>c.hex===h) || {name:h,code:"",hex:h});
// the inks a layer needs, bottom to top
function inkStack(h){
  if(h===VINYL) return [];
  const c=colourByHex(h), me=c.swatch?`${c.code} (${c.swatch})`:c.name;
  if(scheme.material==="holo"&&c.code==="01A") return [];   // white on holo = bare foil, no ink
  if(!isFluoro()||isBlack(h)) return [me];
  if(c.code==="01A") return [`${WHITE_INK.code}`];   // fluoro white is RDG_WHITE on its own
  return [WHITE_INK.code, me];
}
// make the colour scheme legal for the chosen vinyl; returns what was changed, in words
// outline 1 must differ from the colours on either side of it, or it would disappear into them
function neighbours(key){
  if(key==="letter") return [scheme.o1];
  if(key==="o1") return [scheme.letter].concat(scheme.outlines===2?[scheme.o2]:[]);
  if(key==="o2") return scheme.outlines===2?[scheme.o1]:[];
  return [];
}
const hexOf=code=>(COLOURS.find(c=>c.code===code)||{}).hex;
// the best legal colour for a layer, avoiding its neighbours
function pickColour(key){
  const onCut=isFluoro()&&key===cutKey();
  const order=onCut?[VINYL]
    :[hexOf("01A"),hexOf("21A")].concat(isFluoro()?[VINYL]:[],COLOURS.map(c=>c.hex));
  const nb=neighbours(key);
  return order.find(h=>h&&!nb.includes(h))||order[0];
}
const nameOf=h=>h===VINYL?`the bare ${vinyl().name} vinyl`:label(colourByHex(h));
function enforceVinylRules(){
  const changes=[], nm={letter:"Logo colour",o1:"Outline 1",o2:"Outline 2"};
  const set=(k,why)=>{ scheme[k]=pickColour(k); changes.push(`${nm[k]} is now ${nameOf(scheme[k])}${why}`); };
  if(scheme.material==="holo"&&scheme.finish==="matte"){ scheme.finish="gloss"; changes.push("the lamination is now High gloss, as holographic only comes with a gloss finish"); }
  if(!isFluoro()) ["letter","o1","o2"].forEach(k=>{ if(scheme[k]===VINYL) set(k,""); });
  else { const k=cutKey(); if(!allowedOnCut(scheme[k])) set(k,", because the cut runs through it"); }
  // outline 1 can't match the logo or outline 2
  if(scheme.letter===scheme.o1) set("letter",", so it doesn't blend into outline 1");
  if(scheme.outlines===2&&scheme.o2===scheme.o1) set(cutKey()==="o2"&&isFluoro()?"o1":"o2",cutKey()==="o2"&&isFluoro()?", so it stands out from outline 2":", so it doesn't blend into outline 1");
  return changes;
}
const isWhiteC = c => c && c.code==="01A";
// white is 01A on standard vinyl, RDG_WHITE on fluoro, and the bare foil (no ink) on holographic
const label = c => isWhiteC(c) ? (isFluoro()?"RDG_WHITE White":scheme.material==="holo"?"Holographic (bare vinyl, no ink)":`${c.code} ${c.name}`)
  : c.code ? `${c.code} ${c.name}` : c.name;

// ---------- state ----------
// one colour scheme for the whole sheet: every logo, and the TKR logo in the strip, share it
const START=CFG.start||{};
const scheme={material:"standard",size:"A4",outlines:START.outlines==="1"?1:2,letter:colourByCode(START.letter||"01A",0),o1:colourByCode(START.o1||"21A",3),o2:colourByCode(START.o2||"43K",14),
  finish:"gloss",holo:"sweep",holoAmt:Math.max(10,Math.min(100,+CFG.holo||40))};
let previewing=false, decals=[], picked=new Set(), primary=null, nextId=1, nextGroup=1, approved=false;
let drag=null, xf=null, mq=null;
let S=1, S0=1, dpr=1, checks={issues:[],bad:new Set()};
const view={z:1,px:0,py:0};   // zoom and pan of the sheet view
let nudgeOn=false, nudgeStep=1;
const $=id=>QS("#"+id);

// ---------- logo sources ----------
// TKR logo library: logos/index.json (name, category, popular, size) + logos/bNN.json bundles of SVG artwork.
const CATS=["Manufacturers","Engines","Tires","Fuel","Shops/Distributors","Handsets","Misc"];
const sources = {};
function trim(c){
  const ctx=c.getContext("2d"), d=ctx.getImageData(0,0,c.width,c.height).data;
  let x0=c.width,y0=c.height,x1=-1,y1=-1;
  for(let y=0;y<c.height;y++)for(let x=0;x<c.width;x++){
    if(d[(y*c.width+x)*4+3]>20){if(x<x0)x0=x;if(x>x1)x1=x;if(y<y0)y0=y;if(y>y1)y1=y;}
  }
  if(x1<0) return null;
  const o=document.createElement("canvas"); o.width=x1-x0+1; o.height=y1-y0+1;
  o.getContext("2d").drawImage(c,-x0,-y0); return o;
}
function addSource(id,name,canvas,extra={}){ sources[id]={id,name,canvas,w:canvas.width,h:canvas.height,...extra}; }

// ---------- distance transform (Felzenszwalb) ----------
const INF=1e20;
function dt1d(f,n,d,v,z){
  let k=0; v[0]=0; z[0]=-INF; z[1]=INF;
  for(let q=1;q<n;q++){
    let s=((f[q]+q*q)-(f[v[k]]+v[k]*v[k]))/(2*q-2*v[k]);
    while(s<=z[k]){k--; s=((f[q]+q*q)-(f[v[k]]+v[k]*v[k]))/(2*q-2*v[k]);}
    k++; v[k]=q; z[k]=s; z[k+1]=INF;
  }
  k=0;
  for(let q=0;q<n;q++){ while(z[k+1]<q)k++; const t=q-v[k]; d[q]=t*t+f[v[k]]; }
}
function edt(mask,w,h){
  const g=new Float64Array(w*h); for(let i=0;i<w*h;i++) g[i]=mask[i]?0:INF;
  const n=Math.max(w,h), f=new Float64Array(n), d=new Float64Array(n), v=new Int32Array(n), z=new Float64Array(n+1);
  for(let x=0;x<w;x++){ for(let y=0;y<h;y++) f[y]=g[y*w+x]; dt1d(f,h,d,v,z); for(let y=0;y<h;y++) g[y*w+x]=d[y]; }
  for(let y=0;y<h;y++){ const o=y*w; for(let x=0;x<w;x++) f[x]=g[o+x]; dt1d(f,w,d,v,z); for(let x=0;x<w;x++) g[o+x]=d[x]; }
  return g;
}
function threshold(dist,r2){ const m=new Uint8Array(dist.length); for(let i=0;i<m.length;i++) m[i]=dist[i]<=r2?1:0; return m; }
function fillHoles(m,w,h){
  const seen=new Uint8Array(w*h), st=new Int32Array(w*h); let sp=0;
  const push=i=>{ if(!m[i]&&!seen[i]){seen[i]=1; st[sp++]=i;} };
  for(let x=0;x<w;x++){push(x);push((h-1)*w+x);} for(let y=0;y<h;y++){push(y*w);push(y*w+w-1);}
  while(sp){ const i=st[--sp], x=i%w; if(x>0)push(i-1); if(x<w-1)push(i+1); if(i>=w)push(i-w); if(i<w*(h-1))push(i+w); }
  const o=new Uint8Array(w*h); for(let i=0;i<w*h;i++) o[i]=(m[i]||!seen[i])?1:0; return o;
}
function contour(m,w,h){
  const p=new Path2D();
  const seg=(ax,ay,bx,by)=>{p.moveTo(ax,ay);p.lineTo(bx,by);};
  for(let y=0;y<h-1;y++)for(let x=0;x<w-1;x++){
    const tl=m[y*w+x],tr=m[y*w+x+1],br=m[(y+1)*w+x+1],bl=m[(y+1)*w+x];
    const c=(tl<<3)|(tr<<2)|(br<<1)|bl; if(c===0||c===15) continue;
    const X=x+.5,Y=y+.5, T=[X+.5,Y],R=[X+1,Y+.5],B=[X+.5,Y+1],L=[X,Y+.5];
    switch(c){
      case 1:case 14:seg(...L,...B);break; case 2:case 13:seg(...B,...R);break;
      case 3:case 12:seg(...L,...R);break; case 4:case 11:seg(...T,...R);break;
      case 6:case 9:seg(...T,...B);break;  case 7:case 8:seg(...L,...T);break;
      case 5:seg(...L,...T);seg(...B,...R);break; case 10:seg(...T,...R);seg(...L,...B);break;
    }
  }
  return p;
}
const hexRgb=h=>[parseInt(h.slice(1,3),16),parseInt(h.slice(3,5),16),parseInt(h.slice(5,7),16)];

// logo rotated to any angle, trimmed to its real shape (like Illustrator's bounds after rotating)
function oriented(src,deg){
  deg=((deg%360)+360)%360; if(!deg) return src.canvas;
  src.rotCache=src.rotCache||{}; if(src.rotCache[deg]) return src.rotCache[deg];
  const a=deg*Math.PI/180, cs=Math.abs(Math.cos(a)), sn=Math.abs(Math.sin(a));
  const c=document.createElement("canvas"); c.width=Math.ceil(src.w*cs+src.h*sn)+4; c.height=Math.ceil(src.w*sn+src.h*cs)+4;
  const x=c.getContext("2d"); x.translate(c.width/2,c.height/2); x.rotate(a); x.drawImage(src.canvas,-src.w/2,-src.h/2);
  return src.rotCache[deg]=trim(c)||src.canvas;
}

// ---------- build one decal exactly to the production rules ----------
function build(d){
  const src=sources[d.logo];
  const pxmm = d.len>150?6:8;
  const logoLong = (d.len - 2*OFFSET*scheme.outlines)*pxmm;
  const oc=oriented(src,d.rot);
  const sw=oc.width, sh=oc.height, sc=logoLong/Math.max(sw,sh);
  const lw=sw*sc, lh=sh*sc;
  const pad=Math.ceil((OFFSET*2+HALF+1)*pxmm);
  const W=Math.ceil(lw)+2*pad, H=Math.ceil(lh)+2*pad;
  const c=document.createElement("canvas"); c.width=W; c.height=H;
  const ctx=c.getContext("2d");
  ctx.drawImage(oc,(W-lw)/2,(H-lh)/2,lw,lh);
  const img=ctx.getImageData(0,0,W,H), px=img.data, N=W*H;
  const la=new Float32Array(N), logo=new Uint8Array(N);
  for(let i=0;i<N;i++){ la[i]=px[i*4+3]/255; logo[i]=px[i*4+3]>=128?1:0; }
  const r=OFFSET*pxmm;
  const dLogo=edt(logo,W,H);
  const raw1=threshold(dLogo,r*r), off1=fillHoles(raw1,W,H);
  // pixels in (and just around) the filled-in counters, e.g. the inside of an O, are solid outline 1:
  // without this their soft edge blended towards outline 2 and left a thin ghost ring inside the letter
  let nearHole=null;
  for(let i=0;i<N;i++) if(off1[i]&&!raw1[i]){ const hm=new Uint8Array(N); for(let j=0;j<N;j++) hm[j]=off1[j]&&!raw1[j]?1:0;
    const dh=edt(hm,W,H); nearHole=new Uint8Array(N); for(let j=0;j<N;j++) nearHole[j]=dh[j]<=4?1:0; break; }
  let cut=off1;
  if(scheme.outlines===2){ cut=fillHoles(threshold(edt(off1,W,H),r*r),W,H); }
  const dCut=edt(cut,W,H), rb=BLEED*pxmm;
  const bleed=new Uint8Array(N), keep=new Uint8Array(N), rk2=(HALF*pxmm)**2;
  let kx0=W,ky0=H,kx1=0,ky1=0;
  for(let i=0;i<N;i++) if(dCut[i]<=rk2){ keep[i]=1; const x=i%W,y=(i/W)|0; if(x<kx0)kx0=x;if(x>kx1)kx1=x;if(y<ky0)ky0=y;if(y>ky1)ky1=y; }
  const L=hexRgb(ink(scheme.letter)), O1=hexRgb(ink(scheme.o1)), OUT=hexRgb(ink(scheme.outlines===2?scheme.o2:scheme.o1));
  let bx0=W,by0=H,bx1=0,by1=0,cx0=W,cy0=H,cx1=0,cy1=0;
  for(let i=0;i<N;i++){
    const ab=Math.min(1,Math.max(0,rb-Math.sqrt(dCut[i])+.5));
    if(ab<=0){px[i*4+3]=0;continue;}
    if(ab>=.5) bleed[i]=1;
    let rr=OUT[0],gg=OUT[1],bb=OUT[2];
    if(scheme.outlines===2){
      const a1=(off1[i]&&dLogo[i]>r*r)||(nearHole&&nearHole[i])?1:Math.min(1,Math.max(0,r-Math.sqrt(dLogo[i])+.5));
      rr+=(O1[0]-rr)*a1; gg+=(O1[1]-gg)*a1; bb+=(O1[2]-bb)*a1;
    }
    const al=la[i]; rr+=(L[0]-rr)*al; gg+=(L[1]-gg)*al; bb+=(L[2]-bb)*al;
    px[i*4]=rr;px[i*4+1]=gg;px[i*4+2]=bb;px[i*4+3]=ab*255;
    const x=i%W,y=(i/W)|0;
    if(bleed[i]){if(x<bx0)bx0=x;if(x>bx1)bx1=x;if(y<by0)by0=y;if(y>by1)by1=y;}
    if(cut[i]){if(x<cx0)cx0=x;if(x>cx1)cx1=x;if(y<cy0)cy0=y;if(y>cy1)cy1=y;}
  }
  ctx.putImageData(img,0,0);
  d.b={canvas:c,W,H,pxmm,bleed,keep,kb:{x0:kx0/pxmm,y0:ky0/pxmm,x1:(kx1+1)/pxmm,y1:(ky1+1)/pxmm},cutPath:contour(cut,W,H),
    bb:{x0:bx0/pxmm,y0:by0/pxmm,x1:(bx1+1)/pxmm,y1:(by1+1)/pxmm},
    cb:{x0:cx0/pxmm,y0:cy0/pxmm,x1:(cx1+1)/pxmm,y1:(cy1+1)/pxmm},
    cutW:(cx1-cx0+1)/pxmm,cutH:(cy1-cy0+1)/pxmm,logoMm:logoLong/pxmm};
  d.cells=null;
}

// ---------- geometry helpers ----------
function newDecal(logo,o={}){
  return Object.assign({id:nextId++,logo,len:60,rot:0,x:0,y:0,group:0},o);
}
function bleedAt(d,X,Y){
  const b=d.b, px=Math.floor((X-d.x)*b.pxmm), py=Math.floor((Y-d.y)*b.pxmm);
  if(px<0||py<0||px>=b.W||py>=b.H) return 0; return b.bleed[py*b.W+px];
}
function keepAt(d,X,Y){
  const b=d.b, px=Math.floor((X-d.x)*b.pxmm), py=Math.floor((Y-d.y)*b.pxmm);
  if(px<0||py<0||px>=b.W||py>=b.H) return 0; return b.keep[py*b.W+px];
}
function absBB(d,k="bb"){const q=d.b[k];return{x0:d.x+q.x0,y0:d.y+q.y0,x1:d.x+q.x1,y1:d.y+q.y1};}
function unionBB(list,k="bb"){ let u=null; for(const d of list){const a=absBB(d,k); u=u?{x0:Math.min(u.x0,a.x0),y0:Math.min(u.y0,a.y0),x1:Math.max(u.x1,a.x1),y1:Math.max(u.y1,a.y1)}:a;} return u; }
const cutCentre=d=>({x:d.x+(d.b.cb.x0+d.b.cb.x1)/2, y:d.y+(d.b.cb.y0+d.b.cb.y1)/2});
function setCentre(d,c){ d.x=c.x-(d.b.cb.x0+d.b.cb.x1)/2; d.y=c.y-(d.b.cb.y0+d.b.cb.y1)/2; d.cells=null; }
function rebuildKeep(d){ const c=cutCentre(d); build(d); setCentre(d,c); }
const pickedList=()=>decals.filter(d=>picked.has(d));
const groupOf=d=>d.group?decals.filter(x=>x.group===d.group):[d];
function units(list){ // groups count as one object, like Illustrator
  const m=new Map(), out=[];
  for(const d of list){ if(d.group){ if(!m.has(d.group)){m.set(d.group,[]); out.push(m.get(d.group));} m.get(d.group).push(d);} else out.push([d]); }
  return out;
}
// ---------- smart guides ----------
// While dragging, the selection's cut-line box snaps to: the decal area edges and centre, other decals'
// edges and centres, and exactly CUT_GAP away from a neighbour (the tightest safe spacing).
let guides=[];
function smartSnap(list,dx,dy,free,starts){
  guides=[];
  const round=v=>Math.round(v*2)/2;
  if(free||!$("smartGuides").checked) return [round(dx),round(dy)];
  const tol=7/S, set=new Set(list);
  let U=null; list.forEach((d,i)=>{ const q=d.b.cb, x=starts[i][0], y=starts[i][1], a={x0:x+q.x0,y0:y+q.y0,x1:x+q.x1,y1:y+q.y1};
    U=U?{x0:Math.min(U.x0,a.x0),y0:Math.min(U.y0,a.y0),x1:Math.max(U.x1,a.x1),y1:Math.max(U.y1,a.y1)}:a; });
  const others=decals.filter(d=>!set.has(d)).map(d=>absBB(d,"cb"));
  const axis=(lo,hi,mid,key)=>{
    const m=[lo,mid,hi], best={d:Infinity};
    const k0=key==="x"?"x0":"y0", k1=key==="x"?"x1":"y1";
    const tg=[{v:AREA[k0],kind:"area"},{v:(AREA[k0]+AREA[k1])/2,kind:"area"},{v:AREA[k1],kind:"area"}];
    for(const o of others){
      tg.push({v:o[k0],kind:"edge",o},{v:(o[k0]+o[k1])/2,kind:"edge",o},{v:o[k1],kind:"edge",o});
      tg.push({v:o[k1]+CUT_GAP,kind:"gap",o,side:0},{v:o[k0]-CUT_GAP,kind:"gap",o,side:2});
    }
    for(const t of tg) for(let i=0;i<3;i++){
      if(t.kind==="gap" && i!==t.side) continue;
      const d=t.v-m[i]; if(Math.abs(d)<Math.abs(best.d)&&Math.abs(d)<=tol) Object.assign(best,{d,t,i});
    }
    return best;
  };
  const sx=axis(U.x0+dx,U.x1+dx,(U.x0+U.x1)/2+dx,"x"), sy=axis(U.y0+dy,U.y1+dy,(U.y0+U.y1)/2+dy,"y");
  const nx=sx.t?dx+sx.d:round(dx), ny=sy.t?dy+sy.d:round(dy);
  const M={x0:U.x0+nx,x1:U.x1+nx,y0:U.y0+ny,y1:U.y1+ny};
  const addGuide=(s,ax)=>{
    if(!s.t) return; const t=s.t;
    if(t.kind==="gap"){
      const o=t.o;
      if(ax==="x"){ const y=(Math.max(M.y0,o.y0)+Math.min(M.y1,o.y1))/2, a=t.side===0?o.x1:M.x1, b=t.side===0?M.x0:o.x0;
        guides.push({gap:true,x0:a,x1:b,y0:y,y1:y}); }
      else { const x=(Math.max(M.x0,o.x0)+Math.min(M.x1,o.x1))/2, a=t.side===0?o.y1:M.y1, b=t.side===0?M.y0:o.y0;
        guides.push({gap:true,x0:x,x1:x,y0:a,y1:b}); }
      return;
    }
    if(ax==="x"){ const lo=t.o?Math.min(t.o.y0,M.y0):AREA.y0, hi=t.o?Math.max(t.o.y1,M.y1):AREA.y1; guides.push({x0:t.v,x1:t.v,y0:lo-2,y1:hi+2,area:t.kind==="area"}); }
    else { const lo=t.o?Math.min(t.o.x0,M.x0):AREA.x0, hi=t.o?Math.max(t.o.x1,M.x1):AREA.x1; guides.push({x0:lo-2,x1:hi+2,y0:t.v,y1:t.v,area:t.kind==="area"}); }
  };
  addGuide(sx,"x"); addGuide(sy,"y");
  return [nx,ny];
}
function moveAll(list,dx,dy){ for(const d of list){ d.x+=dx; d.y+=dy; d.cells=null; } }

// ---------- placement ----------
function decalCells(d){
  if(d.cells) return d.cells;
  const bb=d.b.kb, cw=Math.ceil(bb.x1-bb.x0), ch=Math.ceil(bb.y1-bb.y0), out=[];
  for(let j=0;j<ch;j++)for(let i=0;i<cw;i++){
    let hit=0;
    for(let sy=0;sy<4&&!hit;sy++)for(let sx=0;sx<4&&!hit;sx++){
      if(keepAt(d,d.x+bb.x0+i+sx/3,d.y+bb.y0+j+sy/3)) hit=1;
    }
    if(hit) out.push(i,j);
  }
  return d.cells={list:out,cw,ch};
}
function occupancy(except){
  const g=new Uint8Array(GW*GH);
  for(const o of decals){ if(except.has(o)||!o.b) continue;
    const a=absBB(o,"kb");
    for(let Y=a.y0;Y<a.y1;Y+=.25)for(let X=a.x0;X<a.x1;X+=.25){
      if(keepAt(o,X,Y)){const gx=Math.floor(X),gy=Math.floor(Y); if(gx>=0&&gy>=0&&gx<GW&&gy<GH) g[gy*GW+gx]=1;}
    }
  }
  return g;
}
// place a block of decals (one decal, or a group) in the first free spot, keeping their layout
function placeBlock(list,grid){
  const U=unionBB(list,"kb"), parts=list.map(d=>{ d.cells=null; const c=decalCells(d);
    return {d,c,mx:Math.round(d.x+d.b.kb.x0-U.x0),my:Math.round(d.y+d.b.kb.y0-U.y0)}; });
  const bw=Math.max(...parts.map(p=>p.mx+p.c.cw)), bh=Math.max(...parts.map(p=>p.my+p.c.ch));
  for(let y=Math.ceil(AREA.y0-HALF);y<=Math.floor(AREA.y1+HALF)-bh;y++)for(let x=Math.ceil(AREA.x0-HALF);x<=Math.floor(AREA.x1+HALF)-bw;x++){
    let ok=true;
    outer: for(const p of parts){ const L=p.c.list;
      for(let k=0;k<L.length;k+=2){ if(grid[(y+p.my+L[k+1])*GW+x+p.mx+L[k]]){ok=false;break outer;} } }
    if(ok){ for(const p of parts){ const L=p.c.list;
        p.d.x=x+p.mx-p.d.b.kb.x0; p.d.y=y+p.my-p.d.b.kb.y0; p.d.cells=null;
        for(let k=0;k<L.length;k+=2) grid[(y+p.my+L[k+1])*GW+x+p.mx+L[k]]=1; }
      return true; }
  }
  return false;
}
function autoArrange(){
  const us=units(decals).sort((a,b)=>{const A=unionBB(a),B=unionBB(b);return (B.x1-B.x0)*(B.y1-B.y0)-(A.x1-A.x0)*(A.y1-A.y0);});
  const grid=new Uint8Array(GW*GH); let failed=0;
  us.forEach(u=>{ if(!placeBlock(u,grid)) failed++; });
  changed(true); if(failed) note("Some decals didn't fit. Make them smaller or remove a few.");
}

// ---------- align, distribute, group ----------
function align(kind){
  const list=pickedList(); if(!list.length) return;
  const us=units(list);
  const target = us.length===1 ? AREA : unionBB(list,"cb");
  for(const u of us){ const b=unionBB(u,"cb"); let dx=0,dy=0;
    if(kind==="left") dx=target.x0-b.x0;
    if(kind==="right") dx=target.x1-b.x1;
    if(kind==="hcentre") dx=(target.x0+target.x1)/2-(b.x0+b.x1)/2;
    if(kind==="top") dy=target.y0-b.y0;
    if(kind==="bottom") dy=target.y1-b.y1;
    if(kind==="vmiddle") dy=(target.y0+target.y1)/2-(b.y0+b.y1)/2;
    moveAll(u,dx,dy);
  }
  changed(false);
}
function distribute(axis){
  const us=units(pickedList()); if(us.length<3) return;
  const items=us.map(u=>({u,b:unionBB(u,"cb")}));
  const k0=axis==="h"?"x0":"y0", k1=axis==="h"?"x1":"y1";
  items.sort((a,b)=>a.b[k0]-b.b[k0]);
  const start=items[0].b[k0], end=Math.max(...items.map(i=>i.b[k1]));
  const sum=items.reduce((s,i)=>s+i.b[k1]-i.b[k0],0), gap=(end-start-sum)/(items.length-1);
  let cur=start;
  for(const it of items){ const delta=cur-it.b[k0]; moveAll(it.u,axis==="h"?delta:0,axis==="h"?0:delta); cur+=it.b[k1]-it.b[k0]+gap; }
  changed(false);
}
function isOneGroup(list){ return list.length>1 && list[0].group && list.every(d=>d.group===list[0].group); }
function groupSel(){ const list=pickedList(); if(list.length<2) return; const g=nextGroup++; list.forEach(d=>d.group=g); changed(true); }
function ungroupSel(){ pickedList().forEach(d=>d.group=0); changed(true); }

// whole-selection transforms
function scaleSelection(list,f,anchor){
  for(const d of list){ const c=cutCentre(d), nc={x:anchor.x+(c.x-anchor.x)*f,y:anchor.y+(c.y-anchor.y)*f};
    d.len=Math.max(20,Math.min(200,Math.round(d.len*f))); build(d); setCentre(d,nc); }
}
function rotateSelection90(list){
  const u=unionBB(list,"cb"), cx=(u.x0+u.x1)/2, cy=(u.y0+u.y1)/2;
  for(const d of list){ const c=cutCentre(d); d.rot=(Math.round(d.rot/90)*90+90)%360; build(d); setCentre(d,{x:cx-(c.y-cy),y:cy+(c.x-cx)}); }
}

// ---------- checks ----------
function runChecks(){
  const issues=[]; const bad=new Set();
  for(const d of decals){
    const c=absBB(d,"cb"), s=sources[d.logo];
    if(outside(c)){
      issues.push({lv:"bad",t:`${s.name} (${d.len} mm) is outside the decal area. Keep it inside the dashed line within the blue border.`}); bad.add(d.id);}
    if(s.pic) issues.push({lv:"warn",t:`${s.name} contains a photo-style image, so its cut line may be rough. We may tidy it before printing.`});
    if(s.lowRes){ const ppm=Math.max(s.w,s.h)/d.b.logoMm;
      if(ppm<6) issues.push({lv:"warn",t:`${s.name} may print blurry at ${d.len} mm (about ${Math.round(ppm*25.4)} dpi). Upload a larger file or choose a smaller size.`}); }
  }
  for(let i=0;i<decals.length;i++)for(let j=i+1;j<decals.length;j++){
    const a=decals[i],b=decals[j], A=absBB(a,"kb"),B=absBB(b,"kb");
    const x0=Math.max(A.x0,B.x0),x1=Math.min(A.x1,B.x1),y0=Math.max(A.y0,B.y0),y1=Math.min(A.y1,B.y1);
    if(x0>=x1||y0>=y1) continue;
    let hit=false;
    for(let Y=y0;Y<y1&&!hit;Y+=.4)for(let X=x0;X<x1;X+=.4){ if(keepAt(a,X,Y)&&keepAt(b,X,Y)){hit=true;break;} }
    if(hit){ issues.push({lv:"bad",t:`${sources[a.logo].name} and ${sources[b.logo].name} are too close. Cut lines need at least ${CUT_GAP} mm between them.`}); bad.add(a.id);bad.add(b.id);}
  }
  return {issues,bad};
}

// ---------- sheet template ----------
// The template is split in two: the fixed artwork, and a "frame layer" holding the light-blue
// frame and background pattern, which is tinted live in the sheet's outer border colour.
let tplImg=null, tplBitmap=null, overImg=null, overBitmap=null, overImgW=null, overBitmapW=null, orderBox=null, tplTimer=null, frameImg=null, frameMask=null, frameTint=null, frameTintKey="";
const frameColour=()=>ink(scheme.outlines===2?scheme.o2:scheme.o1);
function rasterTemplate(){
  if(!tplImg) return;
  const pxmm=Math.min(S*dpr,10), w=Math.max(1,Math.round(SHEET.w*pxmm)), h=Math.max(1,Math.round(SHEET.h*pxmm));
  if(tplBitmap && tplBitmap.width===w) return;
  const ras=im=>{ const c=document.createElement("canvas"); c.width=w; c.height=h; c.getContext("2d").drawImage(im,0,0,w,h); return c; };
  try{ tplBitmap=ras(tplImg); overBitmap=overImg?ras(overImg):null; overBitmapW=overImgW?ras(overImgW):null; frameMask=frameImg?ras(frameImg):null; frameTintKey=""; }catch(_){ tplBitmap=null; overBitmap=null; overBitmapW=null; frameMask=null; }
  draw();
}
function frameLayer(){
  if(!frameMask) return null;
  const key=frameColour()+frameMask.width+scheme.material;
  if(key!==frameTintKey){
    const c=frameTint&&frameTint.width===frameMask.width?frameTint:document.createElement("canvas");
    c.width=frameMask.width; c.height=frameMask.height; const x=c.getContext("2d");
    x.clearRect(0,0,c.width,c.height); x.drawImage(frameMask,0,0); x.globalCompositeOperation="source-in";
    x.fillStyle=frameColour(); x.fillRect(0,0,c.width,c.height); x.globalCompositeOperation="source-over";
    frameTint=c; frameTintKey=key;
  }
  return frameTint;
}
let tkr=null; // TKR strip logo paths, in template points
const PT=25.4/72;
const svgImage=txt=>new Promise((res,rej)=>{ const im=new Image(); im.onload=()=>res(im); im.onerror=rej;
  im.src=URL.createObjectURL(new Blob([txt],{type:"image/svg+xml"})); });
const tplCache={};
// the end of the <g> that opens at index a (matching nested groups)
function groupEnd(txt,a){ const re=/<g\b[^>]*?(\/?)>|<\/g>/g; re.lastIndex=a; let depth=0, m;
  while((m=re.exec(txt))){ if(m[0]==="</g>"){ if(--depth===0) return m.index+4; } else if(m[1]!=="/") depth++; } return -1; }
function svgBBox(vb,inner){
  const NS="http://www.w3.org/2000/svg", s=document.createElementNS(NS,"svg");
  s.setAttribute("viewBox",vb); s.style.cssText="position:absolute;left:-9999px;top:0;width:10px;height:10px;visibility:hidden";
  s.innerHTML="<g>"+inner+"</g>"; document.body.appendChild(s);
  try{ const b=s.firstChild.getBBox(); return b.width?{x:b.x,y:b.y,w:b.width,h:b.height}:null; } finally{ s.remove(); }
}
// strip text turns white when the sheet's outer outline colour is dark (not on fluoro, where the vinyl is the background)
const hexLum=h=>{ const m=/^#?([0-9a-f]{6})$/i.exec(h||""); if(!m) return 1; const n=parseInt(m[1],16), f=v=>{v/=255;return v<=.03928?v/12.92:Math.pow((v+.055)/1.055,2.4);};
  return .2126*f(n>>16&255)+.7152*f(n>>8&255)+.0722*f(n&255); };
const stripDark=()=>!isFluoro()&&hexLum(frameColour())<0.18;
const ORDER_PLACEHOLDER="#0000";
async function parseTemplate(file,noFrame){
  let txt=await (await fetch(file)).text();
  if(/^\s*\{/.test(txt)) txt=JSON.parse(txt).svg;   // templates can be delivered as JSON so Shopify Files doesn't treat them as images
  const i0=txt.indexOf('<g id="TKR_LOGOS"');
  // the TKR strip logo layer ends where its group closes (LOGOS_HERE, if the file has it, comes straight after)
  let i1=-1;
  if(i0>=0){ const re=/<g\b[^>]*?(\/?)>|<\/g>/g; re.lastIndex=i0; let depth=0, m;
    while((m=re.exec(txt))){ if(m[0]==="</g>"){ if(--depth===0){ i1=m.index+4; break; } } else if(m[1]!=="/") depth++; } }
  let tk=null;
  if(i0>=0&&i1>i0){
    // TKR strip logo: the two cut outlines (ids TWO_OUTLINES / ONE_OUTLINE, any suffix), a base shape, then the letters
    const part=txt.slice(i0,i1), P=d=>new Path2D(d.replace(/\s+/g," "));
    const dOf=re=>{const m=part.match(re);return m?P(m[1]):null;};
    const plainIn=txt=>[...txt.matchAll(/<path\b([^>]*)>/g)].map(m=>m[1]).filter(a=>!/\sid="/.test(a)&&!/fill="none"/.test(a));
    const plain=plainIn(part);
    const letters=new Path2D();
    // the letters are the white (or unfilled) paths; the coloured ones are the logo's base shapes
    plain.filter(a=>{ const f=a.match(/\sfill="([^"]*)"/); return !f||/^#fff(fff)?$/i.test(f[1]); })
      .forEach(a=>{const m=a.match(/\sd="([^"]+)"/); if(m) letters.addPath(P(m[1]));});
    tk={two:dOf(/id="TWO_OUTLINES[^"]*"[^>]*?\sd="([^"]+)"/), one:dOf(/id="ONE_OUTLINE[^"]*"[^>]*?\sd="([^"]+)"/), letters};
    if(!tk.two||!tk.one||plain.length<2) tk=null;
  }
  let base=tk? txt.replace('<g id="TKR_LOGOS"','<g id="TKR_LOGOS" display="none"') : txt;
  // the frame + background pattern: the paths before the sheet's black edge line that are filled
  // light blue (#D4EDFC) or left at the default fill. These are tinted live in the outer border colour.
  const head0=i0>0?base.slice(0,i0):base, tail=i0>0?base.slice(i0):"";
  const edge=head0.search(/<path\b[^>]*fill="none"[^>]*stroke=/), cutAt=edge>0?edge:head0.length;
  const head=head0.slice(0,cutAt), rest=head0.slice(cutAt);
  const isFrame=tag=>{ const f=tag.match(/\sfill="([^"]*)"/); return !/\sid="/.test(tag)&&(!f||/^#D4EDFC$/i.test(f[1])); };
  const framePaths=[...head.matchAll(/<path\b[^>]*\/>/g)].map(m=>m[0]).filter(isFrame);
  let frameIm=null;
  if(framePaths.length&&!noFrame){
    const vb=(txt.match(/viewBox="([^"]+)"/)||[])[1];
    const defs=(head.match(/<defs>[\s\S]*?<\/defs>/)||[""])[0], clip=(head.match(/<clipPath[\s\S]*?<\/clipPath>/)||[""])[0];
    const black=t=>/\sfill="/.test(t)?t.replace(/\sfill="[^"]*"/,' fill="#000"'):t.replace(/^<path\b/,'<path fill="#000"');
    const mask=`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="${vb}">${defs}${clip}${framePaths.map(black).join("")}</svg>`;
    base=head.replace(/<path\b[^>]*\/>/g,t=>isFrame(t)?(/\sfill="/.test(t)?t.replace(/\sfill="[^"]*"/,' fill="none"'):t.replace(/^<path\b/,'<path fill="none"')):t)+rest+tail;
    try{ frameIm=await svgImage(mask); }catch(_){ frameIm=null; }
  }
  let under=base, over=null, overW=null, obox=null;
  if(base.includes('<g id="BACKGROUND"')&&base.includes('<g id="NAME_x2F_SHEET_ID"')){
    under=base.replace('<g id="NAME_x2F_SHEET_ID"','<g id="NAME_x2F_SHEET_ID" display="none"');
    if(noFrame) under=under.replace('<g id="BACKGROUND"','<g id="BACKGROUND" display="none"');   // fluoro: the vinyl itself is the background
    const ov=base.replace('<g id="BACKGROUND"','<g id="BACKGROUND" display="none"');
    const a=ov.indexOf('<g id="NAME_x2F_SHEET_ID"'), b=groupEnd(ov,a);
    over=ov;
    if(b>a){
      // the strip text, ORDER ID box and sample order number. The sample number is the paths in the opposite
      // colour to the rest of the strip; it is taken out and the real order number is added at production.
      const grp=ov.slice(a,b), tags=[...grp.matchAll(/<path\b[^>]*>/g)].map(m=>m[0]);
      const cls=t=>{ const f=t.match(/\sfill="([^"]*)"/); return f&&/^#fff(fff)?$/i.test(f[1])?"w":"k"; };
      const first=tags[0], isNum=t=>first&&cls(t)!==cls(first);
      const num=tags.filter(isNum);
      const vb=(txt.match(/viewBox="([^"]+)"/)||[])[1];
      if(num.length&&num.length<12&&vb) obox=svgBBox(vb,num.join(""));
      const recol=ink=>grp.replace(/<path\b[^>]*>/g,t=>obox&&isNum(t)?"":/\sfill="/.test(t)?t.replace(/\sfill="[^"]*"/,` fill="${ink}"`):t.replace(/^<path\b/,`<path fill="${ink}"`));
      over=ov.slice(0,a)+recol("#000000")+ov.slice(b); overW=ov.slice(0,a)+recol("#FFFFFF")+ov.slice(b);
    }
  }
  return {img:await svgImage(under), over:over?await svgImage(over):null, overW:overW?await svgImage(overW):null, obox, frame:frameIm, tkr:tk};
}
let tplWant="";
const tplKeyFor=size=>size+(isFluoro()?"-fluoro":"");
async function loadTemplate(size){
  const key=tplKeyFor(size), file=isFluoro()?SHEETS[size].fluoroFile:SHEETS[size].file;
  if(tplWant===key&&tplImg) return;
  tplWant=key; tplImg=null; overImg=null; overBitmap=null; overImgW=null; overBitmapW=null; orderBox=null; frameImg=null; tkr=null; tplBitmap=null; frameMask=null; frameTintKey="";
  try{
    if(!tplCache[key]) tplCache[key]=parseTemplate(file,isFluoro());   // fluoro sheets have no frame or pattern
    const t=await tplCache[key]; if(tplWant!==key) return;
    tplImg=t.img; overImg=t.over; overImgW=t.overW; orderBox=t.obox; frameImg=t.frame; tkr=t.tkr; tplBitmap=null; rasterTemplate();
  }catch(e){ delete tplCache[key]; if(tplWant===key){ tplImg=null; draw(); } console.warn("Template failed",e); }
}
// the order number in the ORDER ID box: a placeholder here, the real Shopify order number is added at production
function drawOrderNo(dark){
  if(!orderBox) return;
  const b=orderBox; ctx.save(); ctx.scale(PT,PT); ctx.translate(b.x+b.w/2,b.y+b.h/2); ctx.rotate(-Math.PI/2);
  let fs=b.w/0.7; ctx.font=`700 ${fs}px "Barlow Condensed", sans-serif`;
  const tw=ctx.measureText(ORDER_PLACEHOLDER).width; if(tw>b.h){ fs*=b.h/tw; ctx.font=`700 ${fs}px "Barlow Condensed", sans-serif`; }
  ctx.textAlign="center"; ctx.textBaseline="middle"; ctx.fillStyle=dark?"#000000":"#ffffff";
  ctx.fillText(ORDER_PLACEHOLDER,0,fs*0.04); ctx.restore();
}
function drawTkr(k,showCut){
  if(!tkr||!tplBitmap) return;
  ctx.save(); ctx.scale(PT,PT); ctx.lineJoin="round";
  const bleedW=2*BLEED/PT;
  if(scheme.outlines===2){
    ctx.fillStyle=ink(scheme.o2); ctx.strokeStyle=ink(scheme.o2); ctx.lineWidth=bleedW; ctx.fill(tkr.two); ctx.stroke(tkr.two);
    ctx.fillStyle=ink(scheme.o1); ctx.fill(tkr.one);
  } else { ctx.fillStyle=ink(scheme.o1); ctx.strokeStyle=ink(scheme.o1); ctx.lineWidth=bleedW; ctx.fill(tkr.one); ctx.stroke(tkr.one); }
  ctx.fillStyle=ink(scheme.letter); ctx.fill(tkr.letters);
  if(showCut){ ctx.strokeStyle=tok("--cut"); ctx.lineWidth=1.2/(k*PT); ctx.stroke(scheme.outlines===2?tkr.two:tkr.one); }
  ctx.restore();
}

// ---------- lamination preview (visual only) ----------
const reduceMotion=matchMedia("(prefers-reduced-motion: reduce)").matches;
let light={x:SHEET.w*0.3,y:SHEET.h*0.2}, grain=null;
function grainCanvas(){
  if(grain) return grain;
  const c=document.createElement("canvas"); c.width=c.height=160; const x=c.getContext("2d"), d=x.createImageData(160,160);
  for(let i=0;i<d.data.length;i+=4){ const v=Math.random()*255; d.data[i]=d.data[i+1]=d.data[i+2]=v; d.data[i+3]=13; }
  x.putImageData(d,0,0); return grain=c;
}
// Holographic preview styles. Each texture is generated once, then composited over the sheet.
const HOLO_STYLES=[["sweep","Rainbow sweep"],["tkr","Shattered glass"],["sparkle","Sparkle"],["ice","Cracked ice"]];
const holoTex={};
const hsl=(h,s,l)=>{ const a=s*Math.min(l,1-l), f=n=>{const k=(n+h/30)%12; return l-a*Math.max(-1,Math.min(k-3,9-k,1));}; return [f(0)*255,f(8)*255,f(4)*255]; };
function makeTex(W,H,fn){
  const c=document.createElement("canvas"); c.width=W; c.height=H;
  const x=c.getContext("2d"), d=x.createImageData(W,H), p=d.data;
  for(let j=0;j<H;j++)for(let i=0;i<W;i++){ const o=(j*W+i)*4, [r,g,b]=fn(i,j); p[o]=r; p[o+1]=g; p[o+2]=b; p[o+3]=255; }
  x.putImageData(d,0,0); return c;
}
function holoTexture(style){
  if(holoTex[style]) return holoTex[style];
  let c;
  if(style==="rings"){
    // spectrum rings radiating from the light, gently warped, with metallic grain
    c=makeTex(560,560,(i,j)=>{
      const u=i/560-0.5, v=j/560-0.5, rr=Math.hypot(u,v), ang=Math.atan2(v,u);
      const t=(rr+0.018*Math.sin(ang*5+rr*20)+0.012*Math.sin(ang*9-rr*31)+0.008*Math.sin((u-v)*55))*4.6;
      const glint=0.5+0.5*Math.sin(t*Math.PI*2*3.1+1.3), n=(Math.random()-0.5)*26;
      const [r,g,b]=hsl(((t*360+350)%360+360)%360,0.9,0.62+glint*0.14); return [r+n,g+n,b+n];
    });
  } else if(style==="sweep"){
    // classic laser holo: broad diagonal rainbow bands that slide across the sheet
    c=makeTex(520,360,(i,j)=>{
      const u=i/520, v=j/360, warp=0.05*Math.sin(v*8.5+u*2.6)+0.035*Math.sin(u*13+v*4.1)+0.02*Math.sin((u+v)*27);
      const t=(u*0.78+v*0.62+warp)*2.8, glint=0.5+0.5*Math.sin(t*Math.PI*2*3.1+1.3), n=(Math.random()-0.5)*22;
      const [r,g,b]=hsl(((t*360+350)%360+360)%360,1,0.57+glint*0.15); return [r+n,g+n,b+n];
    });
  } else if(style==="sparkle"){
    // glitter holo: tiny square facets, each catching a different colour
    const W=640,H=440,cell=3, cols=Math.ceil(W/cell), rows=Math.ceil(H/cell), f=[];
    for(let q=0;q<cols*rows;q++) f.push([Math.random()*360, Math.random()]);
    c=makeTex(W,H,(i,j)=>{
      const [h,b]=f[((j/cell)|0)*cols+((i/cell)|0)], lit=b>0.82?0.80:b>0.55?0.66:0.56;
      return hsl(h,b>0.82?1:0.55,lit);
    });
  } else {
    // cracked ice: angular shards (Voronoi), each with its own rainbow sweep at its own angle
    const W=420,H=290,N=170,seeds=[];
    for(let q=0;q<N;q++) seeds.push({x:Math.random()*W,y:Math.random()*H,a:Math.random()*Math.PI,h:Math.random()*360});
    c=makeTex(W,H,(i,j)=>{
      let best=1e9,bs=null,second=1e9;
      for(const sd of seeds){ const d=(sd.x-i)**2+(sd.y-j)**2; if(d<best){second=best;best=d;bs=sd;} else if(d<second) second=d; }
      const edge=Math.sqrt(second)-Math.sqrt(best)<1.2;   // thin bright crack lines between shards
      const t=((i-bs.x)*Math.cos(bs.a)+(j-bs.y)*Math.sin(bs.a))/38, n=(Math.random()-0.5)*18;
      const [r,g,b]=hsl(((bs.h+t*360)%360+360)%360,0.85,edge?0.86:0.6); return [r+n,g+n,b+n];
    });
  }
  return holoTex[style]=c;
}
let chromeTex=null;
function chromeTexture(){
  if(chromeTex) return chromeTex;
  return chromeTex=makeTex(560,560,(i,j)=>{
    const u=i/560-0.5, v=j/560-0.5, rr=Math.hypot(u,v), ang=Math.atan2(v,u);
    const t=rr*7.5+0.35*Math.sin(ang*3+rr*9)+0.2*Math.sin(ang*7-rr*14);
    let b=0.5+0.5*Math.sin(t*Math.PI*2);  b=b*b*(3-2*b);           // sharpen into crisp bright/dark chrome bands
    const L=(0.42+0.58*b)*255; return [L,L,L];
  });
}
// The holo foil as a layer of its own. On the real sheets this is the base material and the print sits on top:
// no ink = pure foil, coloured ink = tinted metallic, black = black. So the sheet is MULTIPLIED onto this foil.
let driftRaf=0, driftLast=0;
function holoDrift(){ return reduceMotion?0:(performance.now()*0.02)%360; }   // steady 20 degrees a second: a full colour cycle every 18 s
function driftLoop(t){
  driftRaf=0;
  if((scheme.material!=="holo"&&scheme.finish!=="gloss")||reduceMotion||document.hidden) return;
  if(t-driftLast>66 && !drag && !xf){ driftLast=t; draw(); }
  driftRaf=requestAnimationFrame(driftLoop);
}
function startDrift(){ if(!driftRaf&&(scheme.material==="holo"||scheme.finish==="gloss")&&!reduceMotion) driftRaf=requestAnimationFrame(driftLoop); }
document.addEventListener("visibilitychange",startDrift);
let foilC=null;
function foilLayer(st,lx,ly){
  const W=640, H=Math.round(640*SHEET.h/SHEET.w), f=W/SHEET.w;
  if(!foilC){ foilC=document.createElement("canvas"); foilC.width=W; foilC.height=H; }
  const x=foilC.getContext("2d"), hasF="filter" in x;
  x.globalCompositeOperation="source-over"; x.globalAlpha=1; if(hasF) x.filter="none";
  x.fillStyle=st==="sweep"?"#d9dde4":"#e6e9ee"; x.fillRect(0,0,W,H);           // bright silver
  const tex=holoTexture(st==="tkr"?"rings":st);
  let ox=0, oy=0, tw=SHEET.w, th=SHEET.h, hue=0;
  if(st==="tkr"){ const R=SHEET.w*1.25; ox=lx-R; oy=ly-R; tw=th=2*R; }              // rainbow rings around the light
  else if(st==="sweep"){ ox=-(lx/SHEET.w)*SHEET.w*0.5; oy=-(ly/SHEET.h)*SHEET.h*0.3; tw=SHEET.w*1.5; th=SHEET.h*1.3;
    hue=(lx/SHEET.w)*120-(ly/SHEET.h)*50; }                                        // bands slide AND the colours cycle
  else hue=(lx/SHEET.w)*140+(ly/SHEET.h)*60;
  hue+=holoDrift();
  x.imageSmoothingEnabled=st!=="sparkle";
  if(hasF) x.filter=`hue-rotate(${hue.toFixed(0)}deg) saturate(${st==="sweep"?1.45:1.35})`;
  x.globalAlpha=st==="sweep"?1:0.92; x.drawImage(tex,ox*f,oy*f,tw*f,th*f);
  if(hasF) x.filter="none";
  // chrome: crisp bright/dark reflection bands around the light give the polished-metal contrast
  if(hasF) x.filter="none";
  { const R=SHEET.w*0.95; x.globalCompositeOperation="multiply"; x.globalAlpha=st==="sweep"?0.42:0.75;
    x.drawImage(chromeTexture(),(lx-R)*f,(ly-R)*f,2*R*f,2*R*f);
    if(hasF) x.filter=`hue-rotate(${hue.toFixed(0)}deg) saturate(1.6)`;
    x.globalCompositeOperation="color-dodge"; x.globalAlpha=st==="sweep"?0.26:0.18; x.drawImage(tex,ox*f,oy*f,tw*f,th*f);
    if(hasF) x.filter="none"; }
  if(st==="tkr"){                                                                 // faint shattered-glass facets in the film
    x.globalCompositeOperation="soft-light"; x.globalAlpha=0.45; x.drawImage(holoTexture("ice"),0,0,W,H);
  }
  x.globalCompositeOperation="source-over"; x.globalAlpha=1;
  return foilC;
}
let flashC=null;
function sparkleFlash(tex,tint,lx,ly){
  // only the brightest facets, revealed in a pool around the light
  if(!flashC){ flashC=document.createElement("canvas"); flashC.width=tex.width; flashC.height=tex.height; }
  const x=flashC.getContext("2d"), W=flashC.width, H=flashC.height, cx=lx/SHEET.w*W, cy=ly/SHEET.h*H;
  x.globalCompositeOperation="source-over"; x.clearRect(0,0,W,H);
  if("filter" in x) x.filter=tint; x.drawImage(tex,0,0); if("filter" in x) x.filter="none";
  const m=x.createRadialGradient(cx,cy,0,cx,cy,W*0.28);
  m.addColorStop(0,"rgba(0,0,0,1)"); m.addColorStop(1,"rgba(0,0,0,0)");
  x.globalCompositeOperation="destination-in"; x.fillStyle=m; x.fillRect(0,0,W,H);
  x.globalCompositeOperation="source-over";
  return flashC;
}
function drawFinish(k){
  ctx.save(); ctx.beginPath(); ctx.rect(0,0,SHEET.w,SHEET.h); ctx.clip();
  if(scheme.material!=="holo"&&scheme.finish==="gloss"){
    // deeper, richer colour under a clear gloss coat
    ctx.globalCompositeOperation="soft-light"; ctx.fillStyle="rgba(0,0,0,0.05)"; ctx.fillRect(0,0,SHEET.w,SHEET.h);
    ctx.globalCompositeOperation="source-over";
    // radial highlight that follows the light (the pointer): tight bright core, wide soft falloff
    // the pointer no longer moves the shine: it glides around the sheet on its own at a steady pace (one loop every ~18 s)
    const gt=reduceMotion?0:performance.now()/1000*0.35;
    const lx=SHEET.w*(0.5+0.36*Math.cos(gt)), ly=SHEET.h*(0.45+0.28*Math.sin(gt*1.3));
    const g=ctx.createRadialGradient(lx,ly,0,lx,ly,130);
    g.addColorStop(0,"rgba(255,255,255,0.312)"); g.addColorStop(0.12,"rgba(255,255,255,0.204)");
    g.addColorStop(0.35,"rgba(255,255,255,0.084)"); g.addColorStop(0.7,"rgba(255,255,255,0.024)"); g.addColorStop(1,"rgba(255,255,255,0)");
    ctx.fillStyle=g; ctx.fillRect(0,0,SHEET.w,SHEET.h);
  } else if(scheme.material==="holo"){
    // the pointer no longer moves the holo: a fixed light, and the colours cycle on their own at a steady speed
    const st=scheme.holo, amt=scheme.holoAmt/100, lx=SHEET.w*0.32, ly=SHEET.h*0.28, foil=foilLayer(st,lx,ly);
    ctx.imageSmoothingEnabled=true;
    // 1. print onto foil: white becomes chrome holo, colours become tinted metallic, black stays black
    ctx.globalAlpha=amt; ctx.globalCompositeOperation="multiply"; ctx.drawImage(foil,0,0,SHEET.w,SHEET.h);
    // 2. metallic lift so the foil reads bright, not like dull print
    ctx.globalAlpha=amt*0.28; ctx.globalCompositeOperation="screen"; ctx.drawImage(foil,0,0,SHEET.w,SHEET.h);
    ctx.globalAlpha=1; ctx.globalCompositeOperation="source-over";
    // 3. sparkle: facets near the light flash
    if(st==="sparkle"){
      const hue=(lx/SHEET.w)*140+(ly/SHEET.h)*60, tmp=sparkleFlash(holoTexture("sparkle"),("filter" in ctx)?`hue-rotate(${hue.toFixed(0)}deg)`:"none",lx,ly);
      ctx.globalAlpha=0.35*amt; ctx.globalCompositeOperation="screen"; ctx.drawImage(tmp,0,0,SHEET.w,SHEET.h);
      ctx.globalAlpha=1; ctx.globalCompositeOperation="source-over";
    }
    // 4. hard white glare where the light hits, like the photos
    const g=ctx.createRadialGradient(lx,ly,0,lx,ly,90);
    g.addColorStop(0,`rgba(255,255,255,${0.6*amt})`); g.addColorStop(0.1,`rgba(255,255,255,${0.33*amt})`);
    g.addColorStop(0.35,`rgba(255,255,255,${0.075*amt})`); g.addColorStop(1,"rgba(255,255,255,0)");
    ctx.globalCompositeOperation="screen"; ctx.fillStyle=g; ctx.fillRect(0,0,SHEET.w,SHEET.h);
    ctx.globalCompositeOperation="source-over";
  } else {
    // matte: lifted blacks, softened colour, fine satin grain, broad diffuse glow
    ctx.globalCompositeOperation="source-over"; ctx.fillStyle="rgba(235,237,240,0.065)"; ctx.fillRect(0,0,SHEET.w,SHEET.h);
    ctx.globalCompositeOperation="saturation"; ctx.fillStyle="rgba(128,128,128,0.06)"; ctx.fillRect(0,0,SHEET.w,SHEET.h);
    ctx.globalCompositeOperation="source-over";
    const pat=ctx.createPattern(grainCanvas(),"repeat");
    if(pat){ pat.setTransform && pat.setTransform(new DOMMatrix().scale(1/(k*0.9))); ctx.fillStyle=pat; ctx.fillRect(0,0,SHEET.w,SHEET.h); }
    const r=ctx.createRadialGradient(light.x,light.y,0,light.x,light.y,170);
    r.addColorStop(0,"rgba(255,255,255,0.04)"); r.addColorStop(1,"rgba(255,255,255,0)");
    ctx.fillStyle=r; ctx.fillRect(0,0,SHEET.w,SHEET.h);
  }
  ctx.restore();
}
let lightRaf=0;
function moveLight(X,Y){
  if(reduceMotion) return;
  light={x:Math.max(-20,Math.min(SHEET.w+20,X)),y:Math.max(-20,Math.min(SHEET.h+20,Y))};
  if(!lightRaf) lightRaf=requestAnimationFrame(()=>{ lightRaf=0; draw(); });
}

// ---------- drawing ----------
const cv=$("sheet"), ctx=cv.getContext("2d");
function tok(n){return getComputedStyle(ROOT).getPropertyValue(n).trim();}
function resize(){
  const stg=QS(".stage"), w=Math.max(200,stg.clientWidth-(innerWidth<=620?0:100)), maxH=Math.max(320,window.innerHeight-(innerWidth>1100?200:260));
  const totalW=SHEET.w+2*MATPAD, totalH=SHEET.h+2*MATPAD;
  S0=Math.min(w/totalW, maxH/totalH); S=S0*view.z; dpr=window.devicePixelRatio||1;
  cv.style.width=(totalW*S0)+"px"; cv.style.height=(totalH*S0)+"px";
  $("sheetWrap").style.width=(totalW*S0)+"px";
  cv.width=Math.round(totalW*S0*dpr); cv.height=Math.round(totalH*S0*dpr); clampView(); draw();
  clearTimeout(tplTimer); tplTimer=setTimeout(rasterTemplate,150);
}
function handles(){
  const a=unionBB(pickedList());
  return {scale:{x:a.x1+1.5,y:a.y1+1.5}, rot:(picked.size===1)?{x:a.x1+1.5,y:a.y0-1.5}:null};
}
function draw(){
  const k=S*dpr; ctx.setTransform(1,0,0,1,0,0);
  ctx.fillStyle=tok("--mat"); ctx.fillRect(0,0,cv.width,cv.height);
  ctx.setTransform(k,0,0,k,(MATPAD*S+view.px)*dpr,(MATPAD*S+view.py)*dpr);
  const mw=SHEET.w+2*MATPAD, mh=SHEET.h+2*MATPAD;
  ctx.lineWidth=1/k;
  for(let x=-MATPAD;x<=mw;x+=10){ctx.strokeStyle=(x%50===0)?tok("--mat-line2"):tok("--mat-line");ctx.beginPath();ctx.moveTo(x,-MATPAD);ctx.lineTo(x,mh);ctx.stroke();}
  for(let y=-MATPAD;y<=mh;y+=10){ctx.strokeStyle=(y%50===0)?tok("--mat-line2"):tok("--mat-line");ctx.beginPath();ctx.moveTo(-MATPAD,y);ctx.lineTo(mw,y);ctx.stroke();}
  ctx.save(); ctx.shadowColor="rgba(0,0,0,.35)"; ctx.shadowBlur=12*dpr; ctx.shadowOffsetY=3*dpr;
  ctx.fillStyle="#ffffff"; ctx.fillRect(0,0,SHEET.w,SHEET.h); ctx.restore();
  if(tplBitmap){ ctx.drawImage(tplBitmap,0,0,SHEET.w,SHEET.h);
    if(isFluoro()){ ctx.save(); ctx.globalCompositeOperation="multiply"; ctx.fillStyle=vinyl().hex; ctx.fillRect(0,0,SHEET.w,SHEET.h); ctx.restore(); }
    const fl=frameLayer(); if(fl) ctx.drawImage(fl,0,0,SHEET.w,SHEET.h);
    const dark=stripDark(), ob=dark&&overBitmapW?overBitmapW:overBitmap;
    if(ob) ctx.drawImage(ob,0,0,SHEET.w,SHEET.h);    // strip text and ORDER ID box sit on top of the frame
    drawOrderNo(dark); }
  else { ctx.fillStyle="#d4edfc"; ctx.fillRect(0,0,SHEET.w,SHEET.h); ctx.fillStyle="#a9a9a9"; ctx.fillRect(FRAME.x0,FRAME.y0,FRAME.x1-FRAME.x0,FRAME.y1-FRAME.y0); }
  const showCut=$("showCut").checked;
  drawTkr(k,showCut);
  // decal area: thin black dashes, a constant 0.8 px on screen whatever the zoom
  ctx.setLineDash([2,1.5]); ctx.strokeStyle="#000000"; ctx.lineWidth=0.8/S;
  if(!previewing) ctx.strokeRect(AREA.x0,AREA.y0,AREA.x1-AREA.x0,AREA.y1-AREA.y0); ctx.setLineDash([]);
  for(const d of decals){
    const b=d.b, inXf=xf&&picked.has(d); ctx.save();
    if(inXf){
      if(xf.mode==="scale"){ ctx.translate(xf.anchor.x,xf.anchor.y); ctx.scale(xf.s,xf.s); ctx.translate(-xf.anchor.x,-xf.anchor.y); }
      else { ctx.translate(xf.c.x,xf.c.y); ctx.rotate(xf.delta); ctx.translate(-xf.c.x,-xf.c.y); }
    }
    ctx.drawImage(b.canvas,d.x,d.y,b.W/b.pxmm,b.H/b.pxmm);
    if(showCut){ ctx.translate(d.x,d.y); ctx.scale(1/b.pxmm,1/b.pxmm);
      ctx.strokeStyle=tok("--cut"); ctx.lineWidth=b.pxmm*1.2/k*(inXf&&xf.s?1/xf.s:1); ctx.stroke(b.cutPath); }
    ctx.restore();
    if(checks.bad.has(d.id) && !inXf && !(drag&&picked.has(d))){ const a=absBB(d); ctx.setLineDash([1.6,1.2]); ctx.strokeStyle=tok("--bad"); ctx.lineWidth=1.6/k*dpr;
      ctx.strokeRect(a.x0-1,a.y0-1,a.x1-a.x0+2,a.y1-a.y0+2); ctx.setLineDash([]); }
  }
  drawFinish(k);
  if(!decals.length){
    const cx=(AREA.x0+AREA.x1)/2, cy=(AREA.y0+AREA.y1)/2;
    const t1="YOUR SHEET IS EMPTY", t2="Pick a logo from the library to start designing";
    ctx.font=`700 ${22/S}px "Barlow Condensed", sans-serif`; const w1=ctx.measureText(t1).width;
    ctx.font=`500 ${14/S}px "Barlow", sans-serif`; const w2=ctx.measureText(t2).width;
    // see-through dark panel behind the message so it reads over the busy background
    const pw=Math.max(w1,w2)+40/S, ph=70/S, px=cx-pw/2, py=cy-36/S;
    ctx.fillStyle="rgba(10,12,16,.55)"; ctx.beginPath();
    if(ctx.roundRect) ctx.roundRect(px,py,pw,ph,12/S); else ctx.rect(px,py,pw,ph); ctx.fill();
    ctx.textAlign="center"; ctx.fillStyle="#ffffff";
    ctx.font=`700 ${22/S}px "Barlow Condensed", sans-serif`; ctx.fillText(t1,cx,cy-4/S);
    ctx.font=`500 ${14/S}px "Barlow", sans-serif`; ctx.fillStyle="rgba(255,255,255,.9)"; ctx.fillText(t2,cx,cy+18/S);
    ctx.textAlign="start";
  }
  // smart guides
  if(drag && guides.length){
    ctx.save(); ctx.strokeStyle=tok("--guide"); ctx.fillStyle=tok("--guide"); ctx.lineWidth=1.2/k*dpr;
    for(const g of guides){
      if(g.gap){
        ctx.beginPath(); ctx.moveTo(g.x0,g.y0); ctx.lineTo(g.x1,g.y1); ctx.stroke();
        const t=1.6, horiz=g.y0===g.y1;
        for(const [px,py] of [[g.x0,g.y0],[g.x1,g.y1]]){ ctx.beginPath(); if(horiz){ctx.moveTo(px,py-t);ctx.lineTo(px,py+t);} else {ctx.moveTo(px-t,py);ctx.lineTo(px+t,py);} ctx.stroke(); }
        const lbl=`${CUT_GAP} mm`; ctx.font=`600 ${10/S}px "IBM Plex Mono", monospace`;
        const tw=ctx.measureText(lbl).width, cx=(g.x0+g.x1)/2, cy=(g.y0+g.y1)/2;
        const bx=horiz?cx-tw/2-3/S:cx+3/S, by=horiz?cy-16/S:cy-7/S;
        ctx.fillRect(bx,by,tw+6/S,13/S); ctx.fillStyle="#ffffff"; ctx.fillText(lbl,bx+3/S,by+10/S); ctx.fillStyle=tok("--guide");
      } else {
        ctx.setLineDash(g.area?[3,2]:[]); ctx.beginPath(); ctx.moveTo(g.x0,g.y0); ctx.lineTo(g.x1,g.y1); ctx.stroke(); ctx.setLineDash([]);
      }
    }
    ctx.restore();
  }
  // marquee
  if(mq){ const x0=Math.min(mq.x0,mq.x1),y0=Math.min(mq.y0,mq.y1);
    ctx.fillStyle="rgba(80,90,255,.10)"; ctx.fillRect(x0,y0,Math.abs(mq.x1-mq.x0),Math.abs(mq.y1-mq.y0));
    ctx.setLineDash([2,1.5]); ctx.strokeStyle=tok("--sel"); ctx.lineWidth=1.2/k*dpr; ctx.strokeRect(x0,y0,Math.abs(mq.x1-mq.x0),Math.abs(mq.y1-mq.y0)); ctx.setLineDash([]); }
  if(xf){
    const txt = xf.mode==="scale" ? (picked.size===1?`${xf.newLen} mm`:`${Math.round(xf.s*100)}%`) : `${xf.newRot}°`;
    ctx.font=`600 ${13/S}px "IBM Plex Mono", monospace`; const tw=ctx.measureText(txt).width;
    ctx.fillStyle=tok("--sel"); ctx.fillRect(xf.px+12/S,xf.py-22/S,tw+10/S,18/S);
    ctx.fillStyle="#ffffff"; ctx.fillText(txt,xf.px+17/S,xf.py-8/S);
  }
  const list=pickedList(), ctrls=$("ctrls");
  if(list.length && !xf){
    const a=unionBB(list); ctx.strokeStyle=tok("--sel");
    if(list.length>1){ ctx.lineWidth=1/k*dpr; ctx.setLineDash([1,1]);
      for(const d of list){ const q=absBB(d); ctx.strokeRect(q.x0-.8,q.y0-.8,q.x1-q.x0+1.6,q.y1-q.y0+1.6); } }
    ctx.lineWidth=2/k*dpr; ctx.setLineDash(isOneGroup(list)?[5,2]:[3,2]);
    ctx.strokeRect(a.x0-1.5,a.y0-1.5,a.x1-a.x0+3,a.y1-a.y0+3); ctx.setLineDash([]);
    const cu=unionBB(list,"cb");
    ctx.font=`500 ${11/S}px "IBM Plex Mono", monospace`;
    const txt = list.length===1 ? `${list[0].b.cutW.toFixed(1)} × ${list[0].b.cutH.toFixed(1)} mm · ${list[0].rot}°`
      : `${list.length} decals${isOneGroup(list)?" · group":""} · ${(cu.x1-cu.x0).toFixed(1)} × ${(cu.y1-cu.y0).toFixed(1)} mm`;
    const tw=ctx.measureText(txt).width; let ty=a.y1+2+12/S; if(ty>SHEET.h+MATPAD-2) ty=a.y0-4;
    ctx.fillStyle=tok("--sel"); ctx.fillRect(a.x0-1.5,ty-11/S,tw+6/S,14/S);
    ctx.fillStyle="#ffffff"; ctx.fillText(txt,a.x0-1.5+3/S,ty);
    if(!drag){
      const h=handles(), r=7/S;
      ctx.fillStyle=tok("--sel"); ctx.strokeStyle="#ffffff"; ctx.lineWidth=1.5/S;
      ctx.fillRect(h.scale.x-r,h.scale.y-r,2*r,2*r); ctx.strokeRect(h.scale.x-r,h.scale.y-r,2*r,2*r);
      ctx.beginPath(); ctx.moveTo(h.scale.x-r*.45,h.scale.y+r*.45); ctx.lineTo(h.scale.x+r*.45,h.scale.y-r*.45); ctx.stroke();
      if(h.rot){
        ctx.beginPath(); ctx.arc(h.rot.x,h.rot.y,r*1.1,0,Math.PI*2); ctx.fill(); ctx.stroke();
        ctx.beginPath(); ctx.arc(h.rot.x,h.rot.y,r*.55,-Math.PI*.9,Math.PI*.55); ctx.stroke();
        const ex=h.rot.x+Math.cos(Math.PI*.55)*r*.55, ey=h.rot.y+Math.sin(Math.PI*.55)*r*.55;
        ctx.beginPath(); ctx.moveTo(ex-r*.4,ey-r*.05); ctx.lineTo(ex,ey); ctx.lineTo(ex+r*.1,ey-r*.45); ctx.stroke();
      }
    }
  }
  if(list.length && !drag && !xf && !mq){
    ctrls.hidden=false;
    $("ctrlSize").textContent = list.length===1 ? `${list[0].len} mm` : `${list.length} items`;
    const g=$("ctrlGroup"); g.hidden = list.length<2;
    const grouped=isOneGroup(list); g.title=grouped?"Ungroup":"Group"; g.setAttribute("aria-label",g.title);
    g.innerHTML = grouped ? '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="8" height="8"/><rect x="13" y="13" width="8" height="8"/></svg>'
      : '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" stroke-dasharray="3 2.5"/><rect x="6.5" y="6.5" width="6" height="6"/><rect x="11.5" y="11.5" width="6" height="6"/></svg>';
    const a=unionBB(list), wrapW=$("sheetWrap").clientWidth, tw=ctrls.offsetWidth||240, th=ctrls.offsetHeight||40;
    let left=(MATPAD+(a.x0+a.x1)/2)*S + view.px - tw/2; left=Math.max(4,Math.min(wrapW-tw-4,left));
    let top=(MATPAD+a.y0-2)*S + view.py - th - 10; if(top<4) top=Math.min((MATPAD+a.y1+2)*S + view.py + 26, cv.clientHeight-th-4); top=Math.max(4,top);
    ctrls.style.left=left+"px"; ctrls.style.top=top+"px";
  } else ctrls.hidden=true;
  $("nudge").hidden=!(nudgeOn&&list.length&&!drag&&!xf&&!mq);
  $("ctrlMove").setAttribute("aria-pressed",nudgeOn);
}

// ---------- editor panel ----------
function swatchRow(key,title,hidden){
  const curHex=scheme[key], fl=isFluoro(), onCut=fl&&key===cutKey(), v=vinyl();
  const opts=(fl?[{hex:VINYL,name:`${v.name} vinyl (no ink)`,code:"",vinyl:true}]:[]).concat(COLOURS);
  const nb=neighbours(key), nbName={letter:"outline 1",o1:"the logo or outline 2",o2:"outline 1"}[key];
  const btn=c=>{ const cutOk=!onCut||allowedOnCut(c.hex), nbOk=!nb.includes(c.hex)||c.hex===curHex, ok=cutOk&&nbOk, nm=c.vinyl?c.name:label(c);
    const tip=ok?nm:!cutOk?`${nm}: not available here. The cut runs through this outline, so on fluoro vinyl it's always the bare vinyl.`
      :`${nm}: already used on ${nbName}. Outline 1 needs a different colour from the logo and outline 2 so it shows.`;
    return `<button class="sw${c.vinyl?" vin":""}" data-k="${key}" data-hex="${c.hex}" ${isWhiteC(c)&&scheme.material==="holo"?' data-holo="1"':""} style="background:${c.vinyl?v.hex:c.hex}" title="${tip}" aria-label="${tip}" aria-pressed="${c.hex===curHex}"${ok?"":" disabled"}></button>`; };
  const stack=inkStack(curHex);
  const how=!fl?"":curHex===VINYL?" · no ink":stack.length>1?" · printed over RDG_WHITE":"";
  return `<div class="row"${hidden?' hidden':''}><span class="t">${title}${onCut?' <span class="cutnote">carries the cut line</span>':""}</span>
    <div class="swatches" role="group" aria-label="${title}">${opts.map(btn).join("")}</div>
    <span class="swname">${label(colourByHex(curHex))}${how}</span>
    ${onCut?`<span class="hint">On fluoro vinyl the cut can't go through stacked ink, so this outline is always the <b>bare vinyl</b>, with no ink.</span>`:""}</div>`;
}
function renderScheme(){
  const el=$("scheme");
  el.innerHTML=`<div class="row" style="gap:10px">
    <div class="row"><span class="t">Outlines</span>
      <div class="seg"><button data-out="1" aria-pressed="${scheme.outlines===1}">1 outline</button><button data-out="2" aria-pressed="${scheme.outlines===2}">2 outlines</button></div></div>
    ${swatchRow("letter","Logo colour")}
    ${swatchRow("o1","Outline 1 colour")}
    ${swatchRow("o2","Outline 2 colour",scheme.outlines===1)}
  </div>`;
  const apply=()=>{ decals.forEach(rebuildKeep); renderScheme(); changed(true); };
  el.querySelectorAll("[data-out]").forEach(b=>b.onclick=()=>{ scheme.outlines=+b.dataset.out; const ch=enforceVinylRules(); apply(); if(ch.length) note(ruleNote(ch)); });
  el.querySelectorAll(".sw").forEach(b=>b.onclick=()=>{ if(b.disabled) return; scheme[b.dataset.k]=b.dataset.hex; const ch=enforceVinylRules(); apply(); if(ch.length) note(ruleNote(ch)); });
  renderFinish();
}
const FINISHES=[["gloss","High gloss","A soft shine glides across the sheet, like tilting it under a light."],
  ["matte","Matte","Soft, low-glare finish."]];
const ruleNote=ch=>`Changed to keep your sheet printable: ${ch.join("; ")}. Press Undo to go back.`;
function renderFinish(){
  const el=$("finish"), fl=isFluoro();
  el.innerHTML=`<h3 class="subh">Vinyl</h3><div class="vinyls" role="group" aria-label="Vinyl">${VINYLS.map(v=>`<button class="vcard" data-vin="${v.id}" aria-pressed="${scheme.material===v.id}"><span class="vsw${v.holo?" fin-holo":""}"${v.holo?"":` style="background:${v.hex}"`}></span><span>${v.name.replace("Fluoro ","Fluoro<br>")}</span></button>`).join("")}</div>
    ${scheme.material==="holo"?`<p class="hint">Printed onto holo foil: white areas show pure foil, colours turn metallic and black stays black.</p>`:""}
    ${fl?`<p class="hint">Black is the only opaque ink, so on fluoro every other colour is printed over a <b>RDG_WHITE</b> underbase for you. You can also leave any layer as the bare fluoro vinyl.</p>`:""}
    <h3 class="subh">Lamination</h3>`
    +FINISHES.map(([v,l,t])=>{ const off=scheme.material==="holo"&&v==="matte"; return `<button class="card" data-fin="${v}" aria-pressed="${scheme.finish===v}"${off?" disabled":""}><span class="sw2 fin-${v}"></span><span><b>${l}</b><small>${off?"Not available on holographic vinyl.":t}</small></span><span class="tick"></span></button>`; }).join("")
    +`<p class="hint">The finish on screen is a preview only. It isn't part of the print file.</p>`;
  el.querySelectorAll("[data-fin]").forEach(b=>b.onclick=()=>{ if(b.disabled) return; scheme.finish=b.dataset.fin; renderFinish(); changed(false); startDrift(); });
  el.querySelectorAll("[data-vin]").forEach(b=>b.onclick=()=>{ if(scheme.material===b.dataset.vin) return;
    scheme.material=b.dataset.vin; const ch=enforceVinylRules(); frameTintKey=""; loadTemplate(scheme.size); decals.forEach(rebuildKeep); renderScheme(); changed(true); startDrift(); if(ch.length) note(ruleNote(ch)); });
  const ha=el.querySelector("#holoAmt");
  if(ha){ ha.oninput=()=>{ scheme.holoAmt=+ha.value; $("holoAmtV").textContent=ha.value+"%"; draw(); }; ha.onchange=()=>changed(false); }
}
function renderEditor(){
  const el=$("editor"), list=pickedList();
  if(!list.length){ $("edTitle").textContent="Selected decal"; el.innerHTML='<p class="empty">Click a decal on the sheet to change its size or rotation, or drag across empty space to select several.</p><button class="btn" data-go="logos">Add logos</button>'; return; }
  if(list.length===1) return renderSingle(list[0]);
  renderMulti(list);
}
function renderSingle(d){
  const el=$("editor"), s=sources[d.logo];
  $("edTitle").textContent="Selected decal";
  el.innerHTML=`<div class="row" style="gap:10px">
    <div class="title-row"><strong>${s.name}</strong></div>
    <div class="preview"><canvas id="pv"></canvas></div>
    <div class="row"><label class="t" for="len">Size along longest side (to the cut line)</label>
      <div class="sizebox"><input type="range" id="len" min="20" max="200" step="1" value="${d.len}"><input type="number" id="lenN" min="20" max="200" value="${d.len}" aria-label="Size in millimetres"><span class="mono">mm</span></div>
      <span class="hint mono" id="dims">Cut line ${d.b.cutW.toFixed(1)} × ${d.b.cutH.toFixed(1)} mm · logo ${d.b.logoMm.toFixed(1)} mm</span></div>
    <div class="row"><label class="t" for="rotR">Rotation</label>
      <div class="sizebox"><input type="range" id="rotR" min="0" max="355" step="5" value="${d.rot}"><input type="number" id="rotN" min="0" max="359" value="${d.rot}" aria-label="Rotation in degrees"><span class="mono">°</span></div></div>
    <div class="actions"><button class="btn" data-act="rot">Rotate 90°</button><button class="btn" data-act="dup">Duplicate</button><button class="btn" data-act="del">Remove</button></div>
  </div>`;
  drawPreview(d);
  let t; const setLen=v=>{v=Math.max(20,Math.min(200,Math.round(+v||60))); d.len=v; $("len").value=v; $("lenN").value=v;
    clearTimeout(t); t=setTimeout(()=>{ rebuildKeep(d); $("dims").textContent=`Cut line ${d.b.cutW.toFixed(1)} × ${d.b.cutH.toFixed(1)} mm · logo ${d.b.logoMm.toFixed(1)} mm`; drawPreview(d); changed(false); },90);};
  $("len").oninput=e=>setLen(e.target.value); $("lenN").onchange=e=>setLen(e.target.value);
  let tr; const setRot=v=>{v=((Math.round(+v||0)%360)+360)%360; d.rot=v; $("rotR").value=v; $("rotN").value=v;
    clearTimeout(tr); tr=setTimeout(()=>{ rebuildKeep(d); drawPreview(d); changed(false); },120);};
  $("rotR").oninput=e=>setRot(e.target.value); $("rotN").onchange=e=>setRot(e.target.value);
  wireCommon(el,[d]);
}
function renderMulti(list){
  const el=$("editor"), grouped=isOneGroup(list), sameLen=list.every(d=>d.len===list[0].len);
  $("edTitle").textContent= grouped?"Selected group":"Selected decals";
  el.innerHTML=`<div class="row" style="gap:10px">
    <div class="title-row"><strong>${list.length} decals</strong>${grouped?'<span class="chip">Grouped</span>':''}</div>
    <div class="actions">${grouped?'<button class="btn" data-act="ungroup">Ungroup</button>':'<button class="btn" data-act="group">Group</button>'}
      <button class="btn" data-act="dup">Duplicate</button><button class="btn" data-act="del">Remove</button></div>
    <div class="row"><label class="t" for="lenAll">Make all the same size</label>
      <div class="sizebox"><input type="range" id="lenAll" min="20" max="200" step="1" value="${sameLen?list[0].len:60}"><input type="number" id="lenAllN" min="20" max="200" value="${sameLen?list[0].len:""}" placeholder="mixed" aria-label="Size for all in millimetres"><span class="mono">mm</span></div>
      <span class="hint">Each decal keeps its centre. Use Auto-arrange afterwards if they overlap.</span></div>
  </div>`;
  let t; const setAll=v=>{v=Math.max(20,Math.min(200,Math.round(+v||60))); $("lenAll").value=v; $("lenAllN").value=v;
    clearTimeout(t); t=setTimeout(()=>{ list.forEach(d=>{d.len=v; rebuildKeep(d);}); changed(false); },120);};
  $("lenAll").oninput=e=>setAll(e.target.value); $("lenAllN").onchange=e=>setAll(e.target.value);
  wireCommon(el,list);
}
function wireCommon(el,list){
  el.querySelectorAll("[data-act]").forEach(b=>b.onclick=()=>act(b.dataset.act));
}
function drawPreview(d){
  const c=$("pv"); if(!c||!d) return; const b=d.b, r=window.devicePixelRatio||1;
  c.width=c.clientWidth*r; c.height=c.clientHeight*r; const x=c.getContext("2d");
  const s=Math.min((c.width-24*r)/b.W,(c.height-24*r)/b.H);
  x.translate((c.width-b.W*s)/2,(c.height-b.H*s)/2); x.scale(s,s);
  x.drawImage(b.canvas,0,0); x.strokeStyle=tok("--cut"); x.lineWidth=1.2*r/s; x.stroke(b.cutPath);
}

// shared actions for the floating toolbar, panel buttons and keyboard
function act(a){
  const list=pickedList(); if(!list.length) return;
  if(a==="move"){ nudgeOn=!nudgeOn; draw(); return; }
  if(a==="rot"){ if(list.length===1){ const d=list[0]; d.rot=(Math.round(d.rot/90)*90+90)%360; rebuildKeep(d);} else rotateSelection90(list); changed(true); }
  if(a==="smaller"||a==="bigger"){
    if(list.length===1){ const d=list[0], v=Math.max(20,Math.min(200,d.len+(a==="bigger"?5:-5))); if(v!==d.len){ d.len=v; rebuildKeep(d);} }
    else { const u=unionBB(list,"cb"); scaleSelection(list,a==="bigger"?1.05:1/1.05,{x:(u.x0+u.x1)/2,y:(u.y0+u.y1)/2}); }
    changed(true);
  }
  if(a==="group"){ isOneGroup(list)?ungroupSel():groupSel(); }
  if(a==="ungroup") ungroupSel();
  if(a==="dup"){
    const gmap=new Map(), copies=list.map(d=>{ let g=0; if(d.group){ if(!gmap.has(d.group)) gmap.set(d.group,nextGroup++); g=gmap.get(d.group); }
      const n=newDecal(d.logo,{len:d.len,rot:d.rot,x:d.x,y:d.y,group:g}); build(n); return n; });
    const grid=occupancy(new Set()); decals.push(...copies);
    // pop the copy just above the original (clear zones touching = CUT_GAP between cut lines), else below, right, left
    const U=unionBB(copies,"kb"), h=U.y1-U.y0, w=U.x1-U.x0;
    let ok=false;
    for(const [dx,dy] of [[0,-h],[0,h],[w,0],[-w,0]]){ moveAll(copies,dx,dy); if(fitsHere(copies)){ok=true;break;} moveAll(copies,-dx,-dy); }
    if(!ok) ok=placeBlock(copies,grid);
    if(!ok) moveAll(copies,0,-h);
    picked=new Set(copies); primary=copies[0]; changed(true);
    if(!ok) note("There's no free space next to the original, so the copy may overlap. Move it or make room.");
  }
  if(a==="del"){ decals=decals.filter(x=>!picked.has(x)); picked.clear(); primary=null; changed(true); }
}
// does this set of decals sit inside the margin without touching any other decal's bleed?
function fitsHere(list){
  const set=new Set(list), c=unionBB(list,"cb");
  if(outside(c)) return false;
  for(const a of list){ const A=absBB(a,"kb");
    for(const b of decals){ if(set.has(b)) continue; const B=absBB(b,"kb");
      const x0=Math.max(A.x0,B.x0),x1=Math.min(A.x1,B.x1),y0=Math.max(A.y0,B.y0),y1=Math.min(A.y1,B.y1);
      if(x0>=x1||y0>=y1) continue;
      for(let Y=y0;Y<y1;Y+=.4)for(let X=x0;X<x1;X+=.4) if(keepAt(a,X,Y)&&keepAt(b,X,Y)) return false; } }
  return true;
}
$("ctrls").addEventListener("click",e=>{ const b=e.target.closest("button[data-a]"); if(b) act(b.dataset.a); });

// ---------- order + checks panel ----------
function orderData(){
  const gnum=new Map(); let gi=1;
  const col=h=>{const k=colourByHex(h);return k.vinyl?`no ink (${vinyl().name} vinyl)`:isWhiteC(k)&&scheme.material==="holo"?"no ink (Holographic vinyl)":isWhiteC(k)&&isFluoro()?WHITE_INK.swatch:k.swatch?`${k.code} (${k.swatch})`:k.name;};
  const sh=SHEETS[scheme.size];
  const v=currentVariant(); return {product:(CFG.product&&CFG.product.title)||"Sponsor Decal Sheet",variant_id:v?v.id:null,quantity:sheetQty(),sheet:`${isFluoro()?sh.fluoroName:sh.name} (${sh.label}, ${mm1(sh.w)}x${mm1(sh.h)} mm artboard; positions from its top-left)`,sheet_size:sh.label,
    lamination:{gloss:"High gloss",matte:"Matte"}[scheme.finish],
    vinyl:scheme.material==="holo"?`Holographic (${Object.fromEntries(HOLO_STYLES)[scheme.holo]})`:vinyl().name, white_underbase:isFluoro()?"RDG_WHITE directly under every non-black ink layer, same shape, no choke":null,
    layers:[["Logo",scheme.letter],["Outline 1",scheme.o1]].concat(scheme.outlines===2?[["Outline 2",scheme.o2]]:[]).map(([n,h])=>({layer:n,colour:colourByHex(h).vinyl?"none (bare vinyl)":col(h),inks_bottom_to_top:inkStack(h),carries_cut:(n==="Outline 2")===(scheme.outlines===2)&&n!=="Logo"})),
    colours:{outlines:scheme.outlines,letters:col(scheme.letter),outline1:col(scheme.o1),outline2:scheme.outlines===2?col(scheme.o2):null,
      applies_to:"all logos plus the TKR strip logo",frame_and_pattern:col(scheme.outlines===2?scheme.o2:scheme.o1)},
    strip:{text_and_order_box:isFluoro()?"black (fixed on fluoro)":stripDark()?"WHITE (outer outline is dark): strip text and ORDER ID box inverted, order number in black":"black",
      order_number:"put the Shopify order number (e.g. #4185) in the ORDER ID box",
      order_number_area_mm:orderBox?{x:+(orderBox.x*PT).toFixed(1),y:+(orderBox.y*PT).toFixed(1),w:+(orderBox.w*PT).toFixed(1),h:+(orderBox.h*PT).toFixed(1)}:null},
    decalCount:decals.length,customerApproved:approved,
    decals:decals.map((d,i)=>{const c=absBB(d,"cb");
      if(d.group&&!gnum.has(d.group)) gnum.set(d.group,gi++);
      return {n:i+1,logo:sources[d.logo].name,file:sources[d.logo].file||null,user_upload:sources[d.logo].user?uploadLabel(d.logo):false,length_mm:d.len,
        rotate:d.rot,group:d.group?gnum.get(d.group):null,cut_x_mm:+c.x0.toFixed(1),cut_y_mm:+c.y0.toFixed(1),
        cut_w_mm:+d.b.cutW.toFixed(1),cut_h_mm:+d.b.cutH.toFixed(1)};})};
}
// compact code the Illustrator print script reads (TKR1~ + short JSON): sheet, vinyl, finish, the ink stack of each
// layer (logo, outline 1, outline 2; spot swatch names), strip colour, the logo files used, and per decal
// [logo index, length mm, rotation, cut-line centre x, centre y, cut width, cut height] in mm from the sheet's top-left
function printCode(id){
  const sw=t=>{ const m=/\(([^)]+)\)/.exec(t); return m?m[1]:t; };
  const keys=["letter","o1"].concat(scheme.outlines===2?["o2"]:[]);
  const files=[], at=new Map();
  const ref=s=>{ const k=s.user?"U:"+(typeof uploadLabel==="function"?uploadLabel(s.id):s.name):(s.file||s.name);
    if(!at.has(k)){ at.set(k,files.length); files.push(k); } return at.get(k); };
  const r1=v=>Math.round(v*100)/100;
  const o={v:1,id:id||"",s:scheme.size,m:scheme.material,f:scheme.finish,o:scheme.outlines,q:sheetQty(),
    k:keys.map(k=>inkStack(scheme[k]).map(sw)),st:isFluoro()?"k":stripDark()?"w":"k",L:files,
    d:decals.map(d=>{ const c=absBB(d,"cb"); return [ref(sources[d.logo]),d.len,d.rot,r1((c.x0+c.x1)/2),r1((c.y0+c.y1)/2),r1(c.x1-c.x0),r1(c.y1-c.y0)]; })};
  return "TKR1~"+JSON.stringify(o);
}
function note(msg){ checks.issues.unshift({lv:"warn",t:msg}); renderChecks(); }
function renderChecks(){
  const ul=$("checks"); const list=checks.issues.slice();
  if(!decals.length) list.push({lv:"warn",t:"Your sheet is empty. Add a logo to get started."});
  if(!list.length) list.push({lv:"ok",t:`All ${decals.length} decals are inside the decal area with at least ${CUT_GAP} mm between cut lines.`});
  ul.innerHTML=list.map(i=>`<li class="${i.lv==="ok"?"":i.lv}">${i.t}</li>`).join("");
  const blocking=checks.issues.some(i=>i.lv==="bad")||!decals.length;
  $("basket").disabled = blocking || !$("approve").checked;
  $("count").textContent=`${decals.length} decal${decals.length===1?"":"s"}${picked.size?` · ${picked.size} selected`:""}`;
  approved=$("approve").checked && !blocking;
  $("orderOut").textContent=JSON.stringify(orderData(),null,2);
  updateBar(blocking);
}
function updateTools(){
  const list=pickedList(), us=units(list);
  QSA("[data-al]").forEach(b=>b.disabled=!list.length);
  QSA("[data-di]").forEach(b=>b.disabled=us.length<3);
  $("alignLbl").textContent = us.length===1 ? "Align to sheet" : "Align";
  $("grpBtn").disabled = list.length<2 || isOneGroup(list);
  $("ungrpBtn").disabled = !list.some(d=>d.group);
}
// ---------- undo / redo ----------
// each step stores the sheet colours and every decal's logo, size, rotation, position and group;
// the already-built decal artwork is kept with it, so stepping back is instant
const history=[]; let hIdx=-1, restoring=false;
function snapshot(){
  return {scheme:{...scheme}, nextGroup,
    decals:decals.map(d=>({id:d.id,logo:d.logo,len:d.len,rot:d.rot,x:d.x,y:d.y,group:d.group,b:d.b}))};
}
const sigOf=sn=>JSON.stringify([sn.scheme,sn.decals.map(d=>[d.id,d.logo,d.len,d.rot,+d.x.toFixed(2),+d.y.toFixed(2),d.group])]);
function commit(){
  if(restoring) return;
  const sn=snapshot(), sig=sigOf(sn);
  if(hIdx>=0 && history[hIdx].sig===sig) return;
  history.splice(hIdx+1); history.push({sn,sig});
  if(history.length>100) history.shift();
  hIdx=history.length-1; updateUndo();
}
function restore(i){
  const sn=history[i].sn, keepIds=new Set(pickedList().map(d=>d.id));
  const sizeWas=scheme.size; Object.assign(scheme,sn.scheme); nextGroup=sn.nextGroup; startDrift();
  if(scheme.size!==sizeWas) applySheet(scheme.size); else loadTemplate(scheme.size);
  decals=sn.decals.map(o=>({...o,cells:null}));
  picked=new Set(decals.filter(d=>keepIds.has(d.id))); primary=pickedList()[0]||null;
  hIdx=i; restoring=true; renderScheme(); changed(true); restoring=false; updateUndo();
}
function undo(){ if(hIdx>0) restore(hIdx-1); }
function redo(){ if(hIdx<history.length-1) restore(hIdx+1); }
function updateUndo(){ $("undoBtn").disabled=hIdx<=0; $("redoBtn").disabled=hIdx>=history.length-1; }
$("undoBtn").onclick=undo; $("redoBtn").onclick=redo;

function changed(editor){
  checks=runChecks(); commit(); if($("approve").checked) $("approve").checked=false; $("added").hidden=true;
  if(editor) renderEditor(); updateTools(); renderChecks(); draw();
}
function selectionChanged(){ renderEditor(); updateTools(); renderChecks(); draw(); }

// ---------- interaction ----------
function toMm(e){const r=cv.getBoundingClientRect(); return {X:(e.clientX-r.left-view.px)/S-MATPAD, Y:(e.clientY-r.top-view.py)/S-MATPAD};}
function hitAll(X,Y){ const out=[]; for(let i=decals.length-1;i>=0;i--){ const d=decals[i], a=absBB(d);
  if(X>=a.x0&&X<=a.x1&&Y>=a.y0&&Y<=a.y1&&bleedAt(d,X,Y)) out.push(d); } return out; }
function hit(X,Y){ for(let i=decals.length-1;i>=0;i--){ const d=decals[i], a=absBB(d);
  if(X>=a.x0&&X<=a.x1&&Y>=a.y0&&Y<=a.y1&&bleedAt(d,X,Y)) return d; } return null; }
function onHandle(X,Y,e){
  if(!picked.size) return null; const h=handles(), lim=(e&&e.pointerType==="touch")?20:13;
  if(Math.hypot((X-h.scale.x)*S,(Y-h.scale.y)*S)<lim) return "scale";
  if(h.rot && Math.hypot((X-h.rot.x)*S,(Y-h.rot.y)*S)<lim) return "rot";
  return null;
}
cv.addEventListener("pointerdown",e=>{
  const {X,Y}=toMm(e), hd=onHandle(X,Y,e), list=pickedList();
  if(hd){
    const a=unionBB(list), h=handles(); cv.setPointerCapture(e.pointerId);
    if(hd==="scale") xf={mode:"scale",anchor:{x:a.x0,y:a.y0},d0:Math.hypot(h.scale.x-a.x0,h.scale.y-a.y0),len0:list[0].len,newLen:list[0].len,s:1,px:X,py:Y};
    else { const d=list[0], c=cutCentre(d); xf={mode:"rot",d,c,a0:Math.atan2(Y-c.y,X-c.x),rot0:d.rot,newRot:d.rot,delta:0,px:X,py:Y}; }
    draw(); return;
  }
  const d=hit(X,Y), add=e.shiftKey||e.metaKey||e.ctrlKey;
  cv.setPointerCapture(e.pointerId);
  if(d){
    const members=groupOf(d), wasPicked=picked.has(d);
    if(add){ if(picked.has(d)) members.forEach(m=>picked.delete(m)); else members.forEach(m=>picked.add(m)); }
    else if(!picked.has(d)) picked=new Set(members);
    primary=d; if(picked.has(d)) openPanel("edit",true);
    if(picked.has(d)){
      const moving=pickedList(); decals=decals.filter(x=>!picked.has(x)).concat(moving);
      drag={list:moving.map(m=>({d:m,ox:X-m.x,oy:Y-m.y})),moved:false,sx:e.clientX,sy:e.clientY,thr:e.pointerType==="touch"?9:3,
        tapX:X,tapY:Y,cycle:wasPicked&&!add}; cv.style.cursor="grabbing";
    }
    selectionChanged();
  } else {
    mq={x0:X,y0:Y,x1:X,y1:Y,add,base:add?new Set(picked):new Set()};
    if(!add){ picked.clear(); primary=null; }
    selectionChanged();
  }
});
cv.addEventListener("pointermove",e=>{
  const {X,Y}=toMm(e);
  if(!drag&&!xf&&!mq) moveLight(X,Y); else { light={x:X,y:Y}; }
  if(xf){
    xf.px=X; xf.py=Y;
    if(xf.mode==="scale"){
      let s=Math.hypot(X-xf.anchor.x,Y-xf.anchor.y)/xf.d0;
      if(picked.size===1){ xf.newLen=Math.max(20,Math.min(200,Math.round(xf.len0*s))); s=xf.newLen/xf.len0; }
      else s=Math.max(.2,Math.min(4,Math.round(s*100)/100));
      xf.s=s;
    } else {
      let raw=xf.rot0+(Math.atan2(Y-xf.c.y,X-xf.c.x)-xf.a0)*180/Math.PI, nr=Math.round(raw/5)*5;
      for(const q of [0,90,180,270,360,-90]) if(Math.abs(raw-q)<4) nr=q;
      xf.delta=(nr-xf.rot0)*Math.PI/180; xf.newRot=((nr%360)+360)%360;
    }
    draw(); return;
  }
  if(mq){
    mq.x1=X; mq.y1=Y;
    const x0=Math.min(mq.x0,X),x1=Math.max(mq.x0,X),y0=Math.min(mq.y0,Y),y1=Math.max(mq.y0,Y);
    const set=new Set(mq.base);
    for(const d of decals){ const a=absBB(d); if(a.x1>=x0&&a.x0<=x1&&a.y1>=y0&&a.y0<=y1) groupOf(d).forEach(m=>set.add(m)); }
    picked=set; draw(); return;
  }
  if(!drag){ const hd=onHandle(X,Y); cv.style.cursor= hd==="scale"?"nwse-resize": hd==="rot"?"crosshair": hit(X,Y)?"grab":"default"; return; }
  const lead=drag.list[0], list=drag.list.map(p=>p.d);
  if(!drag.moved&&!drag.live){ if(Math.hypot(e.clientX-drag.sx,e.clientY-drag.sy)<drag.thr) return; drag.live=true; }
  if(!drag.start){ drag.start=list.map(d=>[d.x,d.y]); drag.x0=lead.d.x; drag.y0=lead.d.y; }
  const [sdx,sdy]=smartSnap(list, X-lead.ox-drag.x0, Y-lead.oy-drag.y0, e.altKey, drag.start);
  const dx=drag.x0+sdx-lead.d.x, dy=drag.y0+sdy-lead.d.y;
  if(dx||dy){ moveAll(list,dx,dy); drag.moved=true; }
  draw();
});
const endDrag=()=>{
  if(xf){ const t=xf; xf=null; const list=pickedList();
    if(t.mode==="scale"){
      if(list.length===1){ const d=list[0]; if(t.newLen!==d.len){ const old=absBB(d); d.len=t.newLen; build(d); d.x=old.x0-d.b.bb.x0; d.y=old.y0-d.b.bb.y0; } }
      else if(t.s!==1) scaleSelection(list,t.s,t.anchor);
      changed(true);
    } else { const d=t.d; if(t.newRot!==d.rot){ d.rot=t.newRot; rebuildKeep(d); changed(true);} else draw(); }
    return; }
  if(mq){ mq=null; primary=pickedList()[0]||null; selectionChanged(); return; }
  if(drag){ cv.style.cursor="grab"; const m=drag.moved, t=drag; drag=null; guides=[];
    if(m){ changed(false); return; }
    if(t.cycle){ const under=hitAll(t.tapX,t.tapY); if(under.length>1){ const i=under.indexOf(primary), nx=under[(i+1)%under.length];
      picked=new Set(groupOf(nx)); primary=nx; selectionChanged(); return; } }
    draw(); } };
cv.addEventListener("pointerup",endDrag); cv.addEventListener("pointercancel",endDrag);
let ddHot=false;
document.addEventListener("pointerdown",e=>{ ddHot=ROOT.contains(e.target)||LAYER.contains(e.target); },true);
window.addEventListener("keydown",e=>{
  if(!(ddHot||ROOT.contains(document.activeElement)||LAYER.contains(document.activeElement))) return;
  if(!$("browser").hidden){ if(e.key==="Escape") closeBrowser(); return; }
  if(/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) return;
  const mod=e.ctrlKey||e.metaKey;
  if(mod&&(e.key==="z"||e.key==="Z")){ e.preventDefault(); e.shiftKey?redo():undo(); return; }
  if(mod&&(e.key==="y"||e.key==="Y")){ e.preventDefault(); redo(); return; }
  if(mod&&(e.key==="a"||e.key==="A")){ e.preventDefault(); picked=new Set(decals); primary=decals[0]||null; selectionChanged(); return; }
  if(!picked.size) return;
  if(e.key==="Escape"){ picked.clear(); primary=null; selectionChanged(); return; }
  if(mod&&(e.key==="g"||e.key==="G")){ e.preventDefault(); e.shiftKey?ungroupSel():groupSel(); return; }
  if(mod&&(e.key==="d"||e.key==="D")){ e.preventDefault(); act("dup"); return; }
  const st=e.shiftKey?5:1, mv={ArrowLeft:[-st,0],ArrowRight:[st,0],ArrowUp:[0,-st],ArrowDown:[0,st]}[e.key];
  if(mv){ e.preventDefault(); moveAll(pickedList(),mv[0],mv[1]); changed(false); }
  if(e.key==="Delete"||e.key==="Backspace"){ e.preventDefault(); act("del"); }
  if(!mod&&(e.key==="r"||e.key==="R")) act("rot");
  if(e.key==="+"||e.key==="=") act("bigger"); if(e.key==="-") act("smaller");
});
QSA("[data-al]").forEach(b=>b.onclick=()=>align(b.dataset.al));
QSA("[data-di]").forEach(b=>b.onclick=()=>distribute(b.dataset.di));
$("grpBtn").onclick=groupSel; $("ungrpBtn").onclick=ungroupSel;
$("showCut").onchange=draw;
$("arrange").onclick=autoArrange;
$("selAll").onclick=()=>{ picked=new Set(decals); primary=decals[0]||null; selectionChanged(); };
$("clear").onclick=()=>{decals=[];picked.clear();primary=null;changed(true);};
$("approve").onchange=renderChecks;
$("basket").onclick=()=>addToCart();
const _protoBasket=()=>{ const el=$("added"); el.hidden=false;
  const q=sheetQty();
  el.innerHTML=`<strong>${q} sheet${q===1?"":"s"} added.</strong> ${decals.length} decals per sheet, approved by you. In the live shop this would go to the Shopify basket with the order data attached, and no proof would be sent.<br><span class="hint">Prototype only: nothing was ordered.</span>`; };
// quantity of identical sheets, 1–99
function sheetQty(){ const v=parseInt($("qty").value,10); return isNaN(v)?1:Math.max(1,Math.min(99,v)); }
function setQty(v){ $("qty").value=Math.max(1,Math.min(99,v)); $("qtyDown").disabled=sheetQty()<=1; $("qtyUp").disabled=sheetQty()>=99; renderChecks(); updatePrice(); }
$("qtyDown").onclick=()=>setQty(sheetQty()-1);
$("qtyUp").onclick=()=>setQty(sheetQty()+1);
$("qty").onchange=()=>setQty(sheetQty());
$("qtyDown").disabled=true;
$("copy").onclick=async()=>{ const t=$("orderOut").textContent;
  try{ await navigator.clipboard.writeText(t); $("copy").textContent="Copied"; setTimeout(()=>$("copy").textContent="Copy order data",1500);}
  catch(_){ const r=document.createRange(); r.selectNodeContents($("orderOut")); const s=getSelection(); s.removeAllRanges(); s.addRange(r); $("copy").textContent="Selected, press Ctrl+C"; } };

// ---------- logo library: three ways to find a logo ----------
let libMode="search", libQuery="", libLetter="", libCat="All", recent=[];
let bQuery="", bCat="All", bSort="az"; const bPicked=new Set();
const norm=t=>t.toLowerCase().replace(/[^a-z0-9]/g,"");
const allLogos=()=>Object.values(sources);
const catsInUse=()=>CATS.concat(allLogos().some(s=>s.user)?["Your uploads"]:[]);
function matches(s,q){ if(!q) return true; const n=norm(q); return norm(s.name).includes(n)||norm(s.cat||"").includes(n)||norm(s.extra||"").includes(n); }
function firstChar(s){ const c=norm(s.name)[0]||"#"; return /[a-z]/.test(c)?c.toUpperCase():"#"; }
function filtered({q="",letter="",cat="All",sort="az"}){
  let list=allLogos().filter(s=>matches(s,q)&&(!letter||firstChar(s)===letter)&&(cat==="All"||s.cat===cat));
  return list.sort(sort==="pop"?(a,b)=>(b.pop||0)-(a.pop||0)||a.name.localeCompare(b.name):(a,b)=>a.name.localeCompare(b.name));
}
const esc=t=>String(t).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const bundleCache={}, bundleLoading={};
function loadBundle(b){
  if(bundleCache[b]) return Promise.resolve(bundleCache[b]);
  return bundleLoading[b] || (bundleLoading[b]=fetch((CFG.logos&&CFG.logos.bundles&&CFG.logos.bundles[b])||`logos/b${String(b).padStart(2,"0")}.json`)
    .then(r=>{ if(!r.ok) throw new Error("HTTP "+r.status); return r.json(); })
    .then(j=>bundleCache[b]=j).catch(e=>{ delete bundleLoading[b]; throw e; }));
}
async function thumbURL(id){
  const s=sources[id]; if(s.url) return s.url;
  const svg=s.svg||(await loadBundle(s.b))[id]; if(!svg) throw new Error("missing artwork");
  return s.url=URL.createObjectURL(new Blob([svg],{type:"image/svg+xml"}));
}
const thumbIO=("IntersectionObserver" in window) ? new IntersectionObserver(es=>es.forEach(e=>{
  if(!e.isIntersecting) return; const img=e.target; thumbIO.unobserve(img); setThumb(img);
}),{rootMargin:"300px"}) : null;
// library thumbnails show every logo in white, the way it prints by default:
// white parts of the artwork are knock-outs (as on the decal), everything else turns white
function whiteThumb(src,isMask){
  return new Promise((res,rej)=>{ const im=new Image(); im.onload=()=>{
    const k=260/Math.max(im.naturalWidth||im.width||260,im.naturalHeight||im.height||100), c=document.createElement("canvas");
    c.width=Math.max(1,Math.round((im.naturalWidth||im.width)*k)); c.height=Math.max(1,Math.round((im.naturalHeight||im.height)*k));
    const x=c.getContext("2d"); x.drawImage(im,0,0,c.width,c.height);
    const d=x.getImageData(0,0,c.width,c.height), p=d.data;
    for(let i=0;i<p.length;i+=4){
      let a=p[i+3];
      if(!isMask&&p[i]>235&&p[i+1]>235&&p[i+2]>235) a=0;   // same knock-out rule as the decal itself, so light greys show solid
      p[i]=p[i+1]=p[i+2]=255; p[i+3]=a; }
    x.putImageData(d,0,0); res(c.toDataURL()); }; im.onerror=rej; im.src=src; });
}
function setThumb(img){
  const s=sources[img.dataset.id]; if(!s) return;
  if(s.thumbW){ img.src=s.thumbW; return; }
  const p=s.user? whiteThumb(s.canvas.toDataURL(),true) : thumbURL(s.id).then(u=>whiteThumb(u,false));
  p.then(u=>{ s.thumbW=u; img.src=u; }).catch(()=>{ img.alt="Preview unavailable"; });
}
function wireThumbs(root){ root.querySelectorAll("img[data-id]").forEach(img=>thumbIO?thumbIO.observe(img):setThumb(img)); }
// turn a library SVG into the single-colour logo shape the decal builder uses (like recolouring the compound path)
async function ensureLogo(id){
  const s=sources[id]; if(s.canvas) return s;
  const url=await thumbURL(id);
  const im=await new Promise((res,rej)=>{ const i=new Image(); i.onload=()=>res(i); i.onerror=()=>rej(new Error("render")); i.src=url; });
  const k=1600/Math.max(s.vw,s.vh), c=document.createElement("canvas");
  c.width=Math.max(1,Math.round(s.vw*k)); c.height=Math.max(1,Math.round(s.vh*k));
  const x=c.getContext("2d"); x.drawImage(im,0,0,c.width,c.height);
  const d=x.getImageData(0,0,c.width,c.height), p=d.data;
  for(let i=0;i<p.length;i+=4){
    const white=p[i]>235&&p[i+1]>235&&p[i+2]>235;   // white shapes are knock-outs, as in the Illustrator files
    p[i+3]=white?0:p[i+3]; p[i]=p[i+1]=p[i+2]=0;
  }
  x.putImageData(d,0,0);
  const t=trim(c); if(!t) throw new Error("empty");
  s.canvas=t; s.w=t.width; s.h=t.height; s.rotCache={};
  return s;
}
function fillGrid(el,list,emptyMsg){
  el.innerHTML = list.length ? list.map(s=>`<button class="logo-btn" data-id="${s.id}" title="Add ${esc(s.name)} to the sheet"><span class="th"><img alt="" data-id="${s.id}"></span><span>${esc(s.name)}</span></button>`).join("")
    : `<p class="libnone">${emptyMsg}</p>`;
  el.querySelectorAll(".logo-btn").forEach(b=>{ b.onclick=()=>addMany([b.dataset.id]); }); wireThumbs(el);
}
function recentHTML(){ return recent.length?`<p class="libsub">Recently added</p><div class="libgrid small" id="libRecent"></div>`:""; }
function fillRecent(){ const el=$("libRecent"); if(el) fillGrid(el,recent.map(id=>sources[id]).filter(Boolean).slice(0,4),""); }
function renderLibrary(){
  QSA("#libMode button").forEach(b=>b.setAttribute("aria-pressed",b.dataset.mode===libMode));
  const body=$("libBody"), n=allLogos().length;
  if(libMode==="search"){
    body.innerHTML=`<div class="libtools"><input class="search" id="libSearch" type="search" placeholder="Search ${n} logos" aria-label="Search logos" value="${esc(libQuery)}">
      <div class="az" id="libAz" role="group" aria-label="Filter by first letter"></div></div>
      ${recentHTML()}<p class="libcount" id="libCount"></p><div class="libgrid" id="libGrid"></div>`;
    $("libSearch").oninput=e=>{ libQuery=e.target.value; libResults(); };
  } else if(libMode==="cats"){
    body.innerHTML=`<div class="libtools"><input class="search" id="libSearch" type="search" placeholder="Search ${n} logos" aria-label="Search logos" value="${esc(libQuery)}">
      <div class="chips" id="libChips" role="group" aria-label="Categories"></div></div>
      ${recentHTML()}<p class="libcount" id="libCount"></p><div class="libgrid" id="libGrid"></div>`;
    $("libSearch").oninput=e=>{ libQuery=e.target.value; libResults(); };
  } else {
    body.innerHTML=`<button class="btn primary" id="openBrowser">Browse all ${n} logos</button>
      <p class="hint">Opens a full-size library with search, categories, sorting by popularity, and adding several logos at once.</p>
      ${recentHTML()}`;
    $("openBrowser").onclick=openBrowser;
  }
  fillRecent(); libResults();
}
function libResults(){
  const grid=$("libGrid"); if(!grid) return;
  if(libMode==="search"){
    const base=filtered({q:libQuery}), have=new Set(base.map(firstChar));
    $("libAz").innerHTML=["All",..."ABCDEFGHIJKLMNOPQRSTUVWXYZ","#"].map(l=>{const v=l==="All"?"":l;
      return `<button data-l="${v}" ${v&&!have.has(v)?"disabled":""} aria-pressed="${libLetter===v}" ${l==="All"?'style="width:auto;padding:0 6px"':""}>${l}</button>`;}).join("");
    $("libAz").querySelectorAll("button").forEach(b=>b.onclick=()=>{ libLetter=b.dataset.l; libResults(); });
    if(libLetter&&!have.has(libLetter)) libLetter="";
    const list=filtered({q:libQuery,letter:libLetter});
    $("libCount").textContent=`${list.length} logo${list.length===1?"":"s"}${libLetter?` starting with ${libLetter}`:""}`;
    fillGrid(grid,list,`No logos match “${esc(libQuery)}”. Try fewer letters, or upload your own below.`);
  } else {
    const base=filtered({q:libQuery}), count=c=>c==="All"?base.length:base.filter(s=>s.cat===c).length;
    $("libChips").innerHTML=["All",...catsInUse()].map(c=>`<button class="chip-btn" data-c="${esc(c)}" aria-pressed="${libCat===c}">${esc(c)}<span>${count(c)}</span></button>`).join("");
    $("libChips").querySelectorAll("button").forEach(b=>b.onclick=()=>{ libCat=b.dataset.c; libResults(); });
    const list=filtered({q:libQuery,cat:libCat,sort:"pop"});
    $("libCount").textContent=`${list.length} logo${list.length===1?"":"s"} in ${libCat==="All"?"all categories":libCat} · most popular first`;
    fillGrid(grid,list,`Nothing in ${esc(libCat)} matches “${esc(libQuery)}”. Try All, or upload your own below.`);
  }
}
QSA("#libMode button").forEach(b=>b.onclick=()=>{ libMode=b.dataset.mode; renderLibrary(); });

// full-size browser
function openBrowser(){ $("browser").hidden=false; $("bSearch").value=bQuery; $("bSort").value=bSort; renderBrowser(); setTimeout(()=>$("bSearch").focus(),30); }
function closeBrowser(){ $("browser").hidden=true; }
function renderBrowser(){
  const base=filtered({q:bQuery}), count=c=>c==="All"?base.length:base.filter(s=>s.cat===c).length;
  $("bCats").innerHTML=["All",...catsInUse()].map(c=>`<button data-c="${esc(c)}" aria-pressed="${bCat===c}">${c==="All"?"All logos":esc(c)}<span>${count(c)}</span></button>`).join("");
  $("bCats").querySelectorAll("button").forEach(b=>b.onclick=()=>{ bCat=b.dataset.c; renderBrowser(); });
  const list=filtered({q:bQuery,cat:bCat,sort:bSort}), g=$("bGrid");
  g.innerHTML = list.length ? list.map(s=>`<button class="btile" data-id="${s.id}" aria-pressed="${bPicked.has(s.id)}"><span class="tick">✓</span><span class="th"><img alt="" data-id="${s.id}"></span>${esc(s.name)}<small>${esc(s.cat||"")}</small></button>`).join("")
    : `<p class="libnone">No logos match “${esc(bQuery)}”${bCat!=="All"?` in ${esc(bCat)}`:""}. Try another word or pick All logos.</p>`;
  wireThumbs(g);
  g.querySelectorAll(".btile").forEach(b=>{
    b.onclick=()=>{ const id=b.dataset.id; bPicked.has(id)?bPicked.delete(id):bPicked.add(id); b.setAttribute("aria-pressed",bPicked.has(id)); browserFoot(); };
    b.ondblclick=()=>{ bPicked.clear(); closeBrowser(); addMany([b.dataset.id]); }; });
  browserFoot();
}
function browserFoot(){
  const n=bPicked.size; $("bAdd").disabled=!n; $("bAdd").textContent=n?`Add ${n} logo${n===1?"":"s"} to sheet`:"Add to sheet";
  $("bInfo").textContent=n?[...bPicked].map(id=>sources[id].name).join(", "):"Click logos to pick several, then add them in one go. Double-click adds one straight away.";
}
$("bSearch").oninput=e=>{ bQuery=e.target.value; renderBrowser(); };
$("bSort").onchange=e=>{ bSort=e.target.value; renderBrowser(); };
$("bClose").onclick=closeBrowser;
$("bClear").onclick=()=>{ bPicked.clear(); renderBrowser(); };
$("bAdd").onclick=()=>{ const ids=[...bPicked]; bPicked.clear(); closeBrowser(); addMany(ids); };
$("browser").addEventListener("click",e=>{ if(e.target.id==="browser") closeBrowser(); });

let busyN=0;
function busy(on,msg){
  busyN+=on?1:-1; let el=$("busyMsg");
  if(busyN>0){ if(!el){ el=document.createElement("div"); el.id="busyMsg"; el.className="busy"; el.setAttribute("role","status"); LAYER.appendChild(el); } el.textContent=msg||"Loading logo…"; }
  else if(el) el.remove();
}
async function addMany(ids){
  busy(true, ids.length>1?`Loading ${ids.length} logos…`:"Loading logo…");
  const res=await Promise.allSettled(ids.map(ensureLogo));
  busy(false);
  const bad=ids.filter((_,i)=>res[i].status!=="fulfilled");
  res.forEach((r,i)=>{ if(r.status!=="fulfilled") console.warn("Logo load failed:",ids[i],r.reason); });
  ids=ids.filter((_,i)=>res[i].status==="fulfilled");
  if(bad.length) note(`${bad.map(id=>sources[id].name).join(", ")} couldn't be loaded. Check your connection and try again.`);
  if(!ids.length) return;
  const added=[]; let failed=0;
  for(const id of ids){
    const d=newDecal(id); build(d); const grid=occupancy(new Set()); decals.push(d);
    if(!placeBlock([d],grid)){ failed++; d.x=AREA.x0-d.b.kb.x0; d.y=AREA.y0-d.b.kb.y0; }
    added.push(d);
  }
  recent=[...new Set([...ids.slice().reverse(),...recent])].slice(0,8);
  picked=new Set(added); primary=added[0]||null; changed(true);
  if(libMode!=="browse"){ const rec=$("libRecent"); if(rec||recent.length) { const q=libQuery; renderLibrary(); } } else renderLibrary();
  if(failed) note(failed===1?"There's no free space for that logo. Make some room, reduce sizes, or use Auto-arrange."
    :`${failed} logos didn't fit. Make some room, reduce sizes, or use Auto-arrange.`);
}
$("upload").onchange=e=>{
  const f=e.target.files[0]; if(!f) return; const url=URL.createObjectURL(f), im=new Image();
  im.onload=()=>{
    const isSvg=/svg/.test(f.type)||/\.svg$/i.test(f.name);
    let w=im.naturalWidth||1000,h=im.naturalHeight||500; if(isSvg){const k=1600/Math.max(w,h); w*=k; h*=k;}
    const c=document.createElement("canvas"); c.width=Math.round(w); c.height=Math.round(h); const x=c.getContext("2d"); x.drawImage(im,0,0,c.width,c.height);
    const id=x.getImageData(0,0,c.width,c.height), p=id.data; let opaque=true;
    for(let i=3;i<p.length;i+=16) if(p[i]<250){opaque=false;break;}
    for(let i=0;i<p.length;i+=4){ let a=p[i+3];
      if(opaque){ const lum=.299*p[i]+.587*p[i+1]+.114*p[i+2]; a=lum<200?255:lum<235?Math.round((235-lum)/35*255):0; }
      p[i]=p[i+1]=p[i+2]=0; p[i+3]=a; }
    x.putImageData(id,0,0); const t=trim(c); URL.revokeObjectURL(url);
    if(!t){ note("That file looks empty. Try a logo on a transparent or white background."); return; }
    const sid="u"+nextId++; addSource(sid,f.name.replace(/\.[^.]+$/,"").slice(0,22),t,{lowRes:!isSvg,user:true,cat:"Your uploads",pop:0,file:f});
    addMany([sid]);
  };
  im.onerror=()=>note("That file couldn't be read. Use a PNG, JPG or SVG.");
  im.src=url; e.target.value="";
};

// ---------- panels, rail and bottom bar ----------
const PANELS={finish:"Vinyl & finish",size:"Sheet size",colours:"Colours",logos:"Add logos",edit:"Edit",order:"Check & order"};
let panel=null, panelPrev=[];
function openPanel(p,auto){
  const app=$("app"), wasClosed=app.classList.contains("closed");
  if(p===panel&&!wasClosed) return;
  if(!auto||p!==panel) { if(panel&&panel!==p) panelPrev.push(panel); if(panelPrev.length>12) panelPrev.shift(); }
  panel=p; app.classList.remove("closed");
  QSA(".dbody>.sec").forEach(el=>el.hidden=el.dataset.p!==p);
  QSA(".rail [data-p]").forEach(b=>b.setAttribute("aria-current",b.dataset.p===p));
  $("dTitle").textContent=PANELS[p]; $("dBack").disabled=!panelPrev.length;
  $("drawer").querySelector(".dbody").scrollTop=0;
  if(p==="edit"){ const l=pickedList(); if(l.length===1) requestAnimationFrame(()=>drawPreview(l[0])); }
  if(wasClosed) requestAnimationFrame(resize);
}
function closePanel(){ $("app").classList.add("closed"); QSA(".rail [data-p]").forEach(b=>b.setAttribute("aria-current",false)); requestAnimationFrame(resize); }
QSA(".rail [data-p]").forEach(b=>b.onclick=()=>{
  if(b.dataset.p===panel&&!$("app").classList.contains("closed")) closePanel(); else openPanel(b.dataset.p); });
$("dClose").onclick=closePanel;
$("dBack").onclick=()=>{ const p=panelPrev.pop(); if(p){ panel=null; openPanel(p,true); panelPrev.pop(); $("dBack").disabled=!panelPrev.length; } };
document.addEventListener("click",e=>{ const g=e.target.closest("[data-go]"); if(g) openPanel(g.dataset.go); });
// icon toggles drive the original checkboxes
function iconToggle(btn,box,on,off){
  const sync=()=>{ $(btn).setAttribute("aria-pressed",$(box).checked); $(btn).querySelector(".tip").textContent=$(box).checked?on:off; };
  $(btn).onclick=()=>{ $(box).checked=!$(box).checked; sync(); $(box).dispatchEvent(new Event("change")); draw(); }; sync(); return sync;
}
iconToggle("sgBtn","smartGuides","Smart guides: on","Smart guides: off");
const syncCut=iconToggle("cutBtn","showCut","Cut lines: shown","Cut lines: hidden");
let cutBeforePreview=true;
$("previewBtn").onclick=()=>{
  previewing=!previewing; $("previewBtn").setAttribute("aria-pressed",previewing);
  $("previewBtn").querySelector("span").textContent=previewing?"Back to editing":"Preview";
  if(previewing){ cutBeforePreview=$("showCut").checked; $("showCut").checked=false; picked.clear(); primary=null; selectionChanged(); }
  else { $("showCut").checked=cutBeforePreview; draw(); }
  syncCut();
};
function updateBar(blocking){
  const fin=FINISHES.find(f=>f[0]===scheme.finish)[1];
  $("prodName").textContent=`${(CFG.product&&CFG.product.title)||"Sponsor Decal Sheet"} · ${SHEETS[scheme.size].label}${scheme.material!=="standard"?" · "+vinyl().name:""} · ${fin}`; updatePrice();
  $("selBadge").hidden=!picked.size; $("selBadge").textContent=picked.size;
  $("issueDot").hidden=!checks.issues.some(i=>i.lv==="bad");
  { const cv=currentVariant(); $("cartBtn").disabled=!decals.length||!cv||!cv.available; }
}
$("cartBtn").onclick=()=>{
  if(!$("basket").disabled){ $("basket").click(); openPanel("order"); return; }
  openPanel("order");
  if(!checks.issues.some(i=>i.lv==="bad")){ const a=$("approveBox"); a.classList.remove("nudge"); void a.offsetWidth; a.classList.add("nudge"); $("approve").focus(); }
};
cv.addEventListener("pointerdown",()=>{ if(previewing) $("previewBtn").click(); },true);

// ---------- welcome pop-up + guided tour ----------
const TOUR=[
  {sel:"#drawer", panel:"finish", title:"1 · Pick your vinyl and finish",
   text:"<p>Choose <b>standard white</b>, <b>holographic</b> or one of five <b>fluoro</b> vinyls, then a <b>High gloss</b> or <b>Matte</b> lamination.</p><p class='hint'>On fluoro, the outer outline is always the bare vinyl, so it cuts cleanly. The shine is only a preview.</p>"},
  {sel:"#drawer", panel:"size", title:"2 · Choose a sheet size",
   text:"<p><b>A4</b> or the smaller <b>A5</b>. You can switch at any time. If your logos won't fit the smaller sheet, they're re-arranged for you.</p>"},
  {sel:"#drawer", panel:"logos", title:"3 · Add your logos",
   text:"<ul><li>Search by name, jump to a letter, or browse by category.</li><li>Click a logo to drop it onto the sheet.</li><li>Can't find one? Upload your own at the bottom of the panel.</li></ul>"},
  {sel:"#sheetWrap", title:"4 · Arrange your sheet",
   text:"<ul><li><b>Drag</b> a logo to move it.</li><li>Drag the <b>corner handles</b> to resize or rotate, or use the small toolbar above it.</li><li>For small logos, <b>zoom in</b> (pinch on a phone) and tap <b>Move precisely</b> for a 1 mm nudge pad.</li><li>Smart guides help you line logos up and keep the safe gap.</li><li>A <b style='color:var(--bad)'>red dashed box</b> means a logo is too close to another or off the sheet.</li></ul>"},
  {sel:"#drawer", panel:"colours", title:"5 · Choose your colours",
   text:"<p>Every logo shares one colour scheme, including the TKR logo in the strip. Pick <b>1 or 2 outlines</b>, then your logo colour and outline colours. The frame and pattern follow your outer outline colour.</p>"},
  {sel:".pill", title:"6 · Line things up",
   text:"<p>Select logos, then <b>align</b>, <b>space them evenly</b> or <b>group</b> them so they move together. With one logo selected, align works against the sheet.</p><p class='hint'>Drag across empty space to select several at once.</p>"},
  {sel:".vtools.l", title:"7 · Handy tools",
   text:"<ul><li><b>Auto-arrange</b> packs everything neatly for you.</li><li>Select all, or clear the sheet.</li><li>Turn smart guides and cut lines on or off.</li><li><b>Undo</b> and <b>redo</b> are on the other side of the sheet.</li></ul>"},
  {sel:".bar .product, #cartBtn", union:true, title:"8 · Check and order",
   text:"<p>When you're happy, press <b>Add to cart</b>. We'll show you the sheet checks; tick to confirm it should be printed exactly as shown.</p><p class='hint'>Use <b>Preview</b> to see the sheet without cut lines first.</p>"},
  {sel:"#tourBtn", title:"You're ready!",
   text:"<p>That's everything. You can replay this tour at any time from <b>How it works</b>. Start by adding your first logo.</p>", last:true}
];
if(Array.isArray(CFG.tour)) CFG.tour.forEach((t,i)=>{ if(TOUR[i]&&t){ if(t.title) TOUR[i].title=t.title; if(t.text) TOUR[i].text=t.text; } });
if(CFG.allowUploads===false) TOUR.forEach(t=>{ t.text=t.text.replace(/<li>[^<]*[Uu]pload[^<]*<\/li>/g,""); });
let tourI=-1, tourBack=null;
const lsGet=k=>{ try{ return localStorage.getItem(k); }catch(_){ return null; } };
const lsSet=(k,v)=>{ try{ localStorage.setItem(k,v); }catch(_){} };
function showWelcome(){ $("welcome").hidden=false; setTimeout(()=>$("wTour").focus(),30); }
function hideWelcome(){ $("welcome").hidden=true; lsSet("tkrDesignerSeen","1"); }
$("wTour").onclick=()=>{ hideWelcome(); startTour(); };
$("wSkip").onclick=()=>{ hideWelcome(); openPanel("logos"); };
$("tourBtn").onclick=startTour;
function startTour(){ tourBack=document.activeElement; $("tour").hidden=false; tourI=-1; tourGo(0); }
function endTour(){
  $("tour").hidden=true; tourI=-1; lsSet("tkrDesignerSeen","1");
  openPanel("logos"); if(tourBack&&tourBack.focus) tourBack.focus();
}
function tourRect(st){
  const els=[...QSA(st.sel)].filter(e=>e.offsetParent!==null);
  if(!els.length) return null;
  const rs=(st.union?els:[els[0]]).map(e=>e.getBoundingClientRect());
  return {left:Math.min(...rs.map(r=>r.left)),top:Math.min(...rs.map(r=>r.top)),right:Math.max(...rs.map(r=>r.right)),bottom:Math.max(...rs.map(r=>r.bottom))};
}
function tourPlace(){
  if(tourI<0) return; const st=TOUR[tourI], r=tourRect(st), hole=$("tourHole"), card=$("tourCard");
  if(!r){ hole.style.cssText="left:50%;top:50%;width:0;height:0"; card.style.left=(innerWidth-card.offsetWidth)/2+"px"; card.style.top=(innerHeight-card.offsetHeight)/2+"px"; return; }
  card.classList.toggle("dock-top",(r.top+r.bottom)/2>innerHeight*0.55);
  const pad=6, L=r.left-pad, T=r.top-pad, W=r.right-r.left+2*pad, H=r.bottom-r.top+2*pad;
  Object.assign(hole.style,{left:L+"px",top:T+"px",width:W+"px",height:H+"px"});
  const cw=card.offsetWidth, ch=card.offsetHeight, g=14, vw=innerWidth, vh=innerHeight;
  let x,y;
  if(L-g-cw>=8){ x=L-g-cw; y=T; }                                   // left of it
  else if(L+W+g+cw<=vw-8){ x=L+W+g; y=T; }                          // right of it
  else if(T+H+g+ch<=vh-8){ x=L; y=T+H+g; }                          // below
  else if(T-g-ch>=8){ x=L; y=T-g-ch; }                              // above
  else { x=(vw-cw)/2; y=vh-ch-16; }
  card.style.left=Math.max(8,Math.min(vw-cw-8,x))+"px"; card.style.top=Math.max(8,Math.min(vh-ch-8,y))+"px";
}
function tourGo(i){
  if(i<0||i>=TOUR.length) return; tourI=i; const st=TOUR[i];
  if(st.panel) openPanel(st.panel); else if(st.sel==="#sheetWrap"&&!decals.length) {}
  $("tTitle").textContent=st.title; $("tStep").textContent=`${i+1}/${TOUR.length}`;
  $("tText").innerHTML=st.text;
  $("tDots").innerHTML=TOUR.map((_,k)=>`<i class="${k===i?"on":""}"></i>`).join("");
  $("tBack").hidden=i===0; $("tNext").textContent=st.last?"Start designing":"Next";
  const r=tourRect(st), el=QS(st.sel);
  if(el&&r&&(r.top<0||r.bottom>innerHeight)) el.scrollIntoView({block:(r.bottom-r.top)>innerHeight*0.8?"start":"center",behavior:"instant"});
  requestAnimationFrame(()=>requestAnimationFrame(tourPlace)); setTimeout(tourPlace,320);
  $("tNext").focus();
}
$("tNext").onclick=()=>{ if(TOUR[tourI].last) endTour(); else tourGo(tourI+1); };
$("tBack").onclick=()=>tourGo(tourI-1);
$("tClose").onclick=endTour;
addEventListener("resize",()=>{ if(tourI>=0) tourPlace(); });
addEventListener("scroll",()=>{ if(tourI>=0) tourPlace(); },true);
document.addEventListener("keydown",e=>{
  const inTour=tourI>=0, inWel=!$("welcome").hidden;
  if(!inTour&&!inWel) return;
  e.stopImmediatePropagation();
  if(e.key==="Escape"){ e.preventDefault(); if(inWel){ hideWelcome(); } else endTour(); }
  else if(inTour&&e.key==="ArrowRight"){ e.preventDefault(); $("tNext").click(); }
  else if(inTour&&e.key==="ArrowLeft"&&tourI>0){ e.preventDefault(); tourGo(tourI-1); }
  else if(e.key==="Tab"){ // keep focus inside the pop-up
    const box=inWel?$("welcome"):$("tourCard"), f=[...box.querySelectorAll("button")].filter(b=>!b.hidden);
    const i=f.indexOf(document.activeElement); e.preventDefault(); f[(i+(e.shiftKey?-1:1)+f.length)%f.length].focus();
  }
},true);


// ---------- zoom, pan, pinch and the nudge pad ----------
function clampView(){
  const W=(SHEET.w+2*MATPAD)*S, H=(SHEET.h+2*MATPAD)*S, cw=cv.clientWidth||W, ch=cv.clientHeight||H;
  view.px=Math.min(0,Math.max(cw-W,view.px)); view.py=Math.min(0,Math.max(ch-H,view.py));
}
function updateZoomUi(){ $("zoomLbl").textContent=Math.round(view.z*100)+"%"; $("zoomOut").disabled=view.z<=1.001; $("zoomFit").disabled=view.z<=1.001; $("zoomIn").disabled=view.z>=5.999; }
function setZoom(z,cx,cy){
  z=Math.max(1,Math.min(6,z));
  if(cx==null){ cx=cv.clientWidth/2; cy=cv.clientHeight/2;
    const l=pickedList(); if(l.length&&z>view.z){ const a=unionBB(l); cx=(MATPAD+(a.x0+a.x1)/2)*S+view.px; cy=(MATPAD+(a.y0+a.y1)/2)*S+view.py; } }
  const mx=(cx-view.px)/S, my=(cy-view.py)/S;
  view.z=z; S=S0*z; view.px=cx-mx*S; view.py=cy-my*S;
  if(z===1){ view.px=view.py=0; }
  clampView(); draw(); updateZoomUi();
  clearTimeout(tplTimer); tplTimer=setTimeout(rasterTemplate,220);
}
function panBy(dx,dy){ view.px+=dx; view.py+=dy; clampView(); draw(); }
$("zoomIn").onclick=()=>setZoom(view.z*1.5);
$("zoomOut").onclick=()=>setZoom(view.z/1.5);
$("zoomFit").onclick=()=>setZoom(1);
cv.addEventListener("wheel",e=>{
  const r=cv.getBoundingClientRect();
  if(e.ctrlKey||e.metaKey){ e.preventDefault(); setZoom(view.z*Math.exp(-e.deltaY*0.0025),e.clientX-r.left,e.clientY-r.top); }
  else if(view.z>1){ e.preventDefault(); panBy(-e.deltaX,-e.deltaY); }     // only takes over scrolling while zoomed in
},{passive:false});
// two fingers pinch and pan; one finger on empty space pans while zoomed in; Space + drag pans with a mouse
const touches=new Map(); let pinch=null, pan=null, spaceDown=false, settle=false;
window.addEventListener("keydown",e=>{ if(e.code==="Space"&&view.z>1&&(ddHot||ROOT.contains(document.activeElement))&&!/INPUT|TEXTAREA|SELECT|BUTTON/.test(document.activeElement.tagName)){ spaceDown=true; cv.style.cursor="grab"; e.preventDefault(); } });
window.addEventListener("keyup",e=>{ if(e.code==="Space"){ spaceDown=false; cv.style.cursor="default"; } });
function cancelGesture(){
  if(drag){ if(drag.start) drag.list.forEach((p,i)=>{ p.d.x=drag.start[i][0]; p.d.y=drag.start[i][1]; p.d.cells=null; }); drag=null; guides=[]; }
  if(mq){ picked=new Set(mq.base); mq=null; }
  xf=null;
}
cv.addEventListener("pointerdown",e=>{
  const r=cv.getBoundingClientRect();
  if(e.pointerType==="touch") touches.set(e.pointerId,{x:e.clientX-r.left,y:e.clientY-r.top});
  if(touches.size>=2){
    e.stopImmediatePropagation(); cancelGesture(); pan=null;
    const [a,b]=[...touches.values()];
    pinch={d0:Math.hypot(a.x-b.x,a.y-b.y)||1,z0:view.z,mx:((a.x+b.x)/2-view.px)/S,my:((a.y+b.y)/2-view.py)/S};
    try{ cv.setPointerCapture(e.pointerId); }catch(_){}
    draw(); return;
  }
  if(settle){ e.stopImmediatePropagation(); return; }    // a finger left over from a pinch does nothing
  const {X,Y}=toMm(e);
  const wantPan=(spaceDown&&e.pointerType!=="touch")||(e.pointerType==="touch"&&view.z>1&&!onHandle(X,Y,e)&&!hit(X,Y));
  if(wantPan){ e.stopImmediatePropagation(); try{ cv.setPointerCapture(e.pointerId); }catch(_){}
    pan={x:e.clientX,y:e.clientY,px:view.px,py:view.py,moved:false}; }
},true);
cv.addEventListener("pointermove",e=>{
  const r=cv.getBoundingClientRect();
  if(touches.has(e.pointerId)) touches.set(e.pointerId,{x:e.clientX-r.left,y:e.clientY-r.top});
  if(pinch&&touches.size>=2){ e.stopImmediatePropagation();
    const [a,b]=[...touches.values()], d=Math.hypot(a.x-b.x,a.y-b.y), cx=(a.x+b.x)/2, cy=(a.y+b.y)/2;
    view.z=Math.max(1,Math.min(6,pinch.z0*d/pinch.d0)); S=S0*view.z; view.px=cx-pinch.mx*S; view.py=cy-pinch.my*S;
    clampView(); draw(); updateZoomUi(); return; }
  if(pinch||settle){ e.stopImmediatePropagation(); return; }
  if(pan){ e.stopImmediatePropagation(); const dx=e.clientX-pan.x, dy=e.clientY-pan.y; if(Math.hypot(dx,dy)>6) pan.moved=true;
    view.px=pan.px+dx; view.py=pan.py+dy; clampView(); draw(); }
},true);
const endPointer=e=>{
  touches.delete(e.pointerId);
  if(pinch){ e.stopImmediatePropagation(); if(touches.size<2){ pinch=null; settle=touches.size>0; clearTimeout(tplTimer); tplTimer=setTimeout(rasterTemplate,220); } return; }
  if(settle){ e.stopImmediatePropagation(); if(!touches.size) settle=false; return; }
  if(pan){ e.stopImmediatePropagation(); const p=pan; pan=null;
    if(!p.moved&&e.pointerType==="touch"){ picked.clear(); primary=null; selectionChanged(); } }   // a tap on empty space still deselects
};
cv.addEventListener("pointerup",endPointer,true); cv.addEventListener("pointercancel",endPointer,true);
// nudge pad: tap to move one step, hold to keep moving
let nudgeTimer=0, nudgeMoved=false;
function nudgeOnce(dx,dy){ const l=pickedList(); if(!l.length) return; moveAll(l,dx*nudgeStep,dy*nudgeStep); nudgeMoved=true; draw(); }
function nudgeStop(){ clearTimeout(nudgeTimer); clearInterval(nudgeTimer); nudgeTimer=0; if(nudgeMoved){ nudgeMoved=false; changed(false); } }
$("nudge").querySelectorAll("[data-n]").forEach(b=>{
  const [dx,dy]=b.dataset.n.split(",").map(Number);
  b.addEventListener("pointerdown",e=>{ e.preventDefault(); nudgeStop(); nudgeOnce(dx,dy);
    nudgeTimer=setTimeout(()=>{ nudgeTimer=setInterval(()=>nudgeOnce(dx,dy),70); },380); });
  ["pointerup","pointerleave","pointercancel"].forEach(t=>b.addEventListener(t,nudgeStop));
  b.addEventListener("keydown",e=>{ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); nudgeOnce(dx,dy); nudgeStop(); } });
});
$("nudgeStep").onclick=()=>{ nudgeStep=nudgeStep===1?0.5:nudgeStep===0.5?5:1; $("nudgeStep").textContent=nudgeStep+" mm"; };
$("nudgeClose").onclick=()=>{ nudgeOn=false; draw(); };
// one-time phone tip
if(matchMedia("(max-width:620px) and (orientation:portrait)").matches&&!lsGet("tkrPhoneTip")) $("phoneTip").hidden=false;
$("phoneTipOk").onclick=()=>{ $("phoneTip").hidden=true; lsSet("tkrPhoneTip","1"); };


// ---------- Shopify: variant, price, add to cart ----------
const nrm=s=>String(s==null?"":s).trim().toLowerCase();
function optionIndex(name){ const o=(CFG.product&&CFG.product.options)||[]; return o.findIndex(x=>nrm(x&&x.name!==undefined?x.name:x)===nrm(name)); }
function currentVariant(){
  const P=CFG.product; if(!P||!Array.isArray(P.variants)||!P.variants.length) return null;
  if(P.variants.length===1) return P.variants[0];
  const O=CFG.options||{}, si=optionIndex(O.size||"Size"), fi=optionIndex(O.finish||"Finish"), vi=optionIndex(O.vinyl||"Vinyl");
  const sv=nrm((O.sizeValues||{})[scheme.size]||scheme.size);
  const fv=nrm((O.finishValues||{})[scheme.finish]||{gloss:"High gloss",matte:"Matte"}[scheme.finish]);
  const vv=nrm((O.vinylValues||{})[scheme.material]||vinyl().name);
  return P.variants.find(v=>(si<0||nrm(v.options[si])===sv)&&(fi<0||nrm(v.options[fi])===fv)&&(vi<0||nrm(v.options[vi])===vv))||null;
}
function formatMoney(cents){
  const fmt=String(CFG.moneyFormat||"£{{amount}}").replace(/<[^>]*>/g,""), n=(+cents||0)/100;
  const withSep=(dec,th,ds)=>{ const p=n.toFixed(dec).split("."); p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,th); return p.join(ds); };
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/,(_,k)=>({amount:withSep(2,",","."),amount_no_decimals:withSep(0,",","."),
    amount_with_comma_separator:withSep(2,".",","),amount_no_decimals_with_comma_separator:withSep(0,".",","),
    amount_with_apostrophe_separator:withSep(2,"'",".")}[k]||withSep(2,",",".")));
}
function updatePrice(){
  const v=currentVariant(), el=$("price"), each=$("priceEach"); if(!el) return;
  if(!CFG.product){ el.textContent=""; each.textContent=""; return; }
  if(!v){ el.innerHTML='<span class="na">Not available in this combination</span>'; each.textContent=""; return; }
  if(!v.available){ el.innerHTML='<span class="na">Sold out</span>'; each.textContent=""; return; }
  const q=sheetQty(); el.textContent=formatMoney(v.price*q); each.textContent=q>1?`${formatMoney(v.price)} each`:"";
}
const uploadLabel=id=>{ const ups=Object.values(sources).filter(s=>s.user&&s.file); const k=ups.findIndex(s=>s.id===id); return k<0?"Uploaded logo":`Uploaded logo ${k+1}`; };
const colourText=()=>{ const n=h=>label(colourByHex(h));
  return scheme.outlines===2?`Logo ${n(scheme.letter)} · Outline 1 ${n(scheme.o1)} · Outline 2 ${n(scheme.o2)}`:`Logo ${n(scheme.letter)} · Outline ${n(scheme.o1)}`; };
function addToCart(){
  const v=currentVariant();
  if(!v){ note("This combination of size, vinyl and finish isn't available to order. Choose another, or contact us."); openPanel("order"); return; }
  if(!v.available){ note("This combination is sold out at the moment."); openPanel("order"); return; }
  const id="TKR-"+Date.now().toString(36).toUpperCase().slice(-6)+Math.random().toString(36).slice(2,5).toUpperCase();
  const f=document.createElement("form"); f.method="post"; f.action=(CFG.routes&&CFG.routes.cartAdd)||"/cart/add";
  f.enctype="multipart/form-data"; f.acceptCharset="UTF-8"; f.hidden=true;
  const add=(name,value)=>{ const i=document.createElement("input"); i.type="hidden"; i.name=name; i.value=String(value); f.appendChild(i); };
  const fin=FINISHES.find(x=>x[0]===scheme.finish)[1];
  add("form_type","product"); add("utf8","✓"); add("id",v.id); add("quantity",sheetQty());
  add("properties[Sheet size]",SHEETS[scheme.size].label); add("properties[Vinyl]",vinyl().name); add("properties[Finish]",fin);
  add("properties[Decals]",decals.length); add("properties[Colours]",colourText());
  add("properties[Design ID]",id); add("properties[_Print code]",printCode(id));
  // logos the customer uploaded travel with the order as files (Shopify stores them on the order line)
  const used=new Set(decals.map(d=>d.logo));
  Object.values(sources).filter(s=>s.user&&s.file&&used.has(s.id)).forEach(s=>{
    const i=document.createElement("input"); i.type="file"; i.name=`properties[${uploadLabel(s.id)}]`;
    try{ const dt=new DataTransfer(); dt.items.add(s.file); i.files=dt.files; }catch(_){}
    f.appendChild(i);
  });
  busy(true,"Adding to cart…"); $("basket").disabled=true; $("cartBtn").disabled=true;
  document.body.appendChild(f); f.submit();
}

// ---------- start with an empty sheet ----------
function applySheet(size){
  setSheetGeometry(size); view.z=1; view.px=view.py=0; foilC=null; light={x:SHEET.w*0.3,y:SHEET.h*0.2};
  const fw=FRAME.x1-FRAME.x0, fh=FRAME.y1-FRAME.y0;
  $("sheetLegend").textContent=`Decal area ${mm1(fw)} × ${mm1(fh)} mm · ${INSET} mm safety gap · ${CUT_GAP} mm between cut lines`;
  $("sizeSeg").innerHTML=Object.entries(SHEETS).map(([k,t])=>{ const f=t.frame;
    return `<button class="card" data-size="${k}" aria-pressed="${k===size}"><span class="sw2 size-${k.toLowerCase()}"></span><span><b>${t.label} decal sheet</b><small>${mm1(t.w)} × ${mm1(t.h)} mm · decal area ${mm1(f.x1-f.x0)} × ${mm1(f.y1-f.y0)} mm</small></span><span class="tick"></span></button>`; }).join("");
  $("sizeSeg").querySelectorAll("[data-size]").forEach(b=>b.onclick=()=>chooseSize(b.dataset.size));
  $("sizeHint").textContent=`Both sizes use the same colours, outlines and finishes. If your logos don't fit when you switch to the smaller sheet, they're re-arranged for you.`;
  loadTemplate(size); resize();
}
function chooseSize(size){
  if(size===scheme.size) return;
  scheme.size=size; applySheet(size);
  // keep the layout where it fits; if anything now hangs off the smaller sheet, re-pack everything
  decals.forEach(d=>d.cells=null);
  if(decals.some(d=>outside(absBB(d,"cb")))){ autoArrange(); note(`Your logos were re-arranged to fit the ${SHEETS[size].label} sheet.`); }
  else changed(true);
}
async function start(){
  openPanel("logos"); panelPrev=[]; $("dBack").disabled=true; applySheet(scheme.size); renderScheme(); updateZoomUi();
  if(CFG.allowUploads===false){ const u=QS("label.upload"); if(u) u.hidden=true; }
  if(CFG.showWelcome!==false&&!lsGet("tkrDesignerSeen")) showWelcome(); resize(); changed(true); startDrift();
  $("libBody").innerHTML='<p class="hint">Loading the logo library…</p>';
  try{
    const idx=await (await fetch((CFG.logos&&CFG.logos.index)||"logos/index.json")).json();
    // hidden logos stay in the file but not in the library; logos added with the Logo Manager carry their artwork inline
    idx.forEach(r=>{ if(r.hidden) return; sources[r.id]={id:r.id,name:r.name,cat:r.cat,pop:r.pop,extra:r.extra||"",file:r.file,pic:r.pic,b:r.b,svg:r.svg||null,vw:r.w,vh:r.h,canvas:null}; });
  }catch(_){ $("libBody").innerHTML='<p class="hint">The logo library couldn\'t be loaded. Refresh the page to try again.</p>'; return; }
  renderLibrary();
}
window.addEventListener("resize",()=>{ resize(); const l=pickedList(); if(l.length===1) drawPreview(l[0]); });
const mql=matchMedia("(prefers-color-scheme: dark)"); mql.addEventListener?.("change",()=>{renderLibrary();draw();});
start();
}
if(document.readyState!=="loading") tkrDecalDesigner(); else document.addEventListener("DOMContentLoaded",tkrDecalDesigner);
// theme editor: start again when the section is re-rendered
document.addEventListener("shopify:section:load",e=>{ if(e.target&&e.target.querySelector&&e.target.querySelector("#tkr-dd")) tkrDecalDesigner(); });
